var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6679 15.6152C55.2657 16.9109 53.616 17.4293 52.2962 16.1099C52.2609 16.0746 52.2374 16.051 52.2138 16.0157C50.8823 14.5903 51.495 12.9294 52.9326 11.5983C54.3584 10.2671 60.7686 8.06433 60.7686 8.06433C60.7686 8.06433 58.0937 14.2841 56.6679 15.6152Z",
    fill: "url(#paint0_radial_578_447492)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6676 15.615C55.2654 16.9108 53.6157 17.4291 52.2959 16.1098L60.7565 8.05237C60.7447 8.08771 60.3794 8.93585 59.8609 10.0549C59.6724 10.4437 59.4721 10.8677 59.2718 11.3036C58.6001 12.6818 57.8106 14.1661 57.1507 15.0613C56.974 15.2852 56.809 15.4854 56.6676 15.615Z",
    fill: "url(#paint1_radial_578_447492)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3025 15.2149C55.1477 16.2868 53.7926 16.6755 52.7203 15.5329C51.648 14.3785 52.1429 13.0474 53.2977 11.9872C53.7691 11.5514 54.9003 10.9977 56.0786 10.503C57.7873 9.78442 59.5784 9.14832 59.5784 9.14832C59.5784 9.14832 59.2367 9.93754 58.7653 10.9506C58.0465 12.5055 56.9978 14.5788 56.3025 15.2149Z",
    fill: "url(#paint2_radial_578_447492)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5381 14.9082C56.4792 14.9907 56.4085 15.085 56.3496 15.1557C56.3732 15.1085 56.4438 15.0378 56.5381 14.9082Z",
    fill: "url(#paint3_radial_578_447492)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4612 9.21918C59.4612 9.21918 57.3284 14.2138 56.1736 15.274C55.9261 15.4978 55.6786 15.698 55.4194 15.863C55.714 15.698 56.0086 15.4742 56.2914 15.2151C57.4462 14.1431 59.579 9.16028 59.579 9.16028C59.579 9.16028 55.6669 10.5149 53.9111 11.5633C55.714 10.5149 59.4612 9.21918 59.4612 9.21918Z",
    fill: "url(#paint4_radial_578_447492)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7908 15.5447C51.7185 14.3903 52.2134 13.0592 53.3682 11.999C54.4287 11.0095 58.8829 9.43102 59.5546 9.19542C59.5663 9.17186 59.5664 9.14832 59.5664 9.14832C59.5664 9.14832 54.4288 10.9153 53.2858 11.9873C52.1428 13.0592 51.636 14.3785 52.7083 15.5329C53.0854 15.9334 53.4979 16.1455 53.9221 16.2044C53.5332 16.1337 53.1443 15.9217 52.7908 15.5447Z",
    fill: "url(#paint5_radial_578_447492)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7448 8.05237C60.7448 8.05237 60.0377 8.55893 59.5664 9.14792C59.5782 9.1597 60.2145 8.64136 60.7448 8.05237Z",
    fill: "url(#paint6_radial_578_447492)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6601 10.1142C59.4716 10.5029 59.2713 10.927 59.0709 11.3628C58.3993 12.7411 57.6098 14.2253 56.9499 15.1206C56.7731 15.3562 56.62 15.5447 56.4668 15.686C55.8541 16.2632 55.1824 16.6755 54.5107 16.864C55.2413 16.7227 55.9837 16.275 56.6671 15.6507C56.8203 15.5093 56.9853 15.3209 57.1502 15.0853C57.7983 14.2018 58.5996 12.7058 59.2713 11.3275C59.4834 10.8917 59.6837 10.4794 59.8604 10.0789C60.3789 8.95978 60.7442 8.11163 60.756 8.07629L60.4614 8.359C60.3082 8.67705 60.0136 9.32493 59.6601 10.1142Z",
    fill: "url(#paint7_radial_578_447492)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.26 11.3153C59.0125 11.1033 58.8594 11.0326 58.8594 11.0326L59.4957 9.64258C59.6371 9.78394 59.7549 9.92529 59.8492 10.0549C59.6724 10.4436 59.4721 10.8795 59.26 11.3153Z",
    fill: "url(#paint8_radial_578_447492)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0727 14.5429C51.0475 15.6385 49.7631 16.1332 48.6555 15.1555C48.6319 15.132 48.6084 15.1084 48.573 15.0848C47.4536 14.0364 47.8542 12.6935 48.9029 11.5627C49.9517 10.4436 54.8772 8.37036 54.8772 8.37036C54.8772 8.37036 53.1332 13.4121 52.0727 14.5429Z",
    fill: "url(#paint9_radial_578_447492)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0725 14.5431C51.0473 15.6386 49.7629 16.1334 48.6553 15.1556L54.877 8.37048C54.8652 8.39404 54.6295 9.08907 54.276 9.98433C54.1582 10.3024 54.0168 10.644 53.8754 10.9973C53.4276 12.1164 52.8855 13.318 52.4142 14.0484C52.2964 14.2604 52.1785 14.4135 52.0725 14.5431Z",
    fill: "url(#paint10_radial_578_447492)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7655 14.2487C50.9171 15.144 49.8684 15.5327 48.9729 14.6964C48.0773 13.8482 48.3837 12.7762 49.2321 11.881C49.5856 11.5158 50.4458 11.0211 51.3414 10.5617C52.6376 9.90199 54.028 9.31299 54.028 9.31299C54.028 9.31299 53.8041 9.94908 53.4859 10.7737C52.991 12.0105 52.2722 13.7068 51.7655 14.2487Z",
    fill: "url(#paint11_radial_578_447492)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9315 13.9894C51.8843 14.0601 51.8372 14.1308 51.79 14.2015C51.8254 14.1543 51.8725 14.0836 51.9315 13.9894Z",
    fill: "url(#paint12_radial_578_447492)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9345 9.37201C53.9345 9.37201 52.5204 13.4125 51.6838 14.3077C51.4953 14.4962 51.3185 14.6611 51.1181 14.8025C51.342 14.6494 51.5659 14.4609 51.7662 14.2488C52.6147 13.3536 54.0169 9.31311 54.0169 9.31311C54.0169 9.31311 51.0121 10.5853 49.6924 11.5042C51.0593 10.5736 53.9345 9.37201 53.9345 9.37201Z",
    fill: "url(#paint13_radial_578_447492)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0328 14.6844C48.1373 13.8363 48.4436 12.7643 49.292 11.869C50.0697 11.0445 53.487 9.56021 54.0172 9.3364C54.029 9.31284 54.029 9.30103 54.029 9.30103C54.029 9.30103 50.0933 10.962 49.2449 11.8573C48.3965 12.7525 48.0784 13.8245 48.9857 14.6726C49.3038 14.9671 49.6338 15.1084 49.9755 15.132C49.6338 15.1084 49.3274 14.9671 49.0328 14.6844Z",
    fill: "url(#paint14_radial_578_447492)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8885 8.38245C54.8885 8.38245 54.3583 8.81828 54.0283 9.30125C54.0283 9.31303 54.4879 8.86542 54.8885 8.38245Z",
    fill: "url(#paint15_radial_578_447492)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1346 10.0434C54.0167 10.3615 53.8754 10.703 53.734 11.0564C53.2862 12.1755 52.7442 13.3771 52.2728 14.1074C52.155 14.2959 52.0371 14.4608 51.9193 14.5786C51.4715 15.0616 50.9648 15.4267 50.4346 15.6034C51.0002 15.4503 51.554 15.0615 52.0607 14.5315C52.1785 14.4137 52.2846 14.2487 52.4142 14.0603C52.8855 13.3299 53.4276 12.1166 53.8754 11.0093C54.0168 10.6559 54.1582 10.3143 54.276 9.99624C54.6295 9.07742 54.8652 8.40601 54.877 8.38245L54.6648 8.61804C54.5706 8.88898 54.382 9.4073 54.1346 10.0434Z",
    fill: "url(#paint16_radial_578_447492)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8875 11.0092C53.6872 10.8561 53.5576 10.809 53.5576 10.809L53.9818 9.68994C54.0997 9.79596 54.1939 9.90194 54.2882 10.008C54.1704 10.3142 54.0289 10.6676 53.8875 11.0092Z",
    fill: "url(#paint17_radial_578_447492)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 15.6148C38.8164 16.9106 40.4661 17.4289 41.7858 16.1096C41.8212 16.0742 41.8447 16.0506 41.8683 16.0153C43.1998 14.59 42.5871 12.929 41.1495 11.5979C39.7237 10.2668 33.3135 8.06396 33.3135 8.06396C33.3135 8.06396 35.9883 14.2837 37.4141 15.6148Z",
    fill: "url(#paint18_radial_578_447492)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 15.6146C38.8163 16.9104 40.466 17.4287 41.7858 16.1094L33.3252 8.052C33.337 8.08734 33.7023 8.93548 34.2208 10.0546C34.4093 10.4433 34.6096 10.8674 34.8099 11.3032C35.4816 12.6815 36.2711 14.1657 36.931 15.061C37.1195 15.2848 37.2727 15.4851 37.4141 15.6146Z",
    fill: "url(#paint19_radial_578_447492)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7798 15.2145C38.9345 16.2865 40.2896 16.6752 41.3619 15.5325C42.4342 14.3781 41.9393 13.0471 40.7846 11.9869C40.3132 11.551 39.182 10.9974 38.0036 10.5026C36.295 9.78406 34.5039 9.14795 34.5039 9.14795C34.5039 9.14795 34.8457 9.93717 35.317 10.9502C36.0476 12.5052 37.0845 14.5784 37.7798 15.2145Z",
    fill: "url(#paint20_radial_578_447492)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5439 14.908C37.6029 14.9904 37.6736 15.0847 37.7325 15.1554C37.7089 15.1083 37.6382 15.0376 37.5439 14.908Z",
    fill: "url(#paint21_radial_578_447492)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.61 9.21881C34.61 9.21881 36.7428 14.2134 37.8976 15.2736C38.1451 15.4974 38.3925 15.6977 38.6517 15.8626C38.3572 15.6977 38.0626 15.4739 37.7798 15.2147C36.625 14.1427 34.4922 9.15991 34.4922 9.15991C34.4922 9.15991 38.4043 10.5146 40.16 11.563C38.3689 10.5146 34.61 9.21881 34.61 9.21881Z",
    fill: "url(#paint22_radial_578_447492)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2911 15.5443C42.3635 14.3899 41.8686 13.0588 40.7138 11.9986C39.6533 11.0091 35.1991 9.43065 34.5274 9.19506C34.5156 9.1715 34.5156 9.14795 34.5156 9.14795C34.5156 9.14795 39.6533 10.9149 40.7963 11.9869C41.9393 13.0588 42.446 14.3781 41.3737 15.5325C40.9966 15.9331 40.5841 16.1451 40.1599 16.204C40.5488 16.1333 40.9376 15.9213 41.2911 15.5443Z",
    fill: "url(#paint23_radial_578_447492)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3369 8.052C33.3369 8.052 34.0439 8.55857 34.5153 9.14756C34.5035 9.15934 33.879 8.64099 33.3369 8.052Z",
    fill: "url(#paint24_radial_578_447492)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4211 10.1138C34.6096 10.5025 34.81 10.9266 35.0103 11.3625C35.6819 12.7407 36.4714 14.2249 37.1313 15.1202C37.3081 15.3558 37.4613 15.5443 37.6144 15.6857C38.2272 16.2629 38.8988 16.6752 39.5705 16.8636C38.8399 16.7223 38.0975 16.2746 37.4141 15.6503C37.2609 15.5089 37.0959 15.3205 36.931 15.0849C36.2829 14.2014 35.4816 12.7054 34.8099 11.3272C34.5978 10.8913 34.3975 10.479 34.2208 10.0785C33.7023 8.95941 33.337 8.11127 33.3252 8.07593L33.6198 8.35863C33.773 8.67668 34.0558 9.32456 34.4211 10.1138Z",
    fill: "url(#paint25_radial_578_447492)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8216 11.3148C35.0691 11.1028 35.2222 11.0321 35.2222 11.0321L34.5859 9.64209C34.4445 9.78345 34.3267 9.9248 34.2324 10.0544C34.4092 10.4431 34.6095 10.879 34.8216 11.3148Z",
    fill: "url(#paint26_radial_578_447492)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0095 14.5428C43.0347 15.6383 44.3191 16.1331 45.4268 15.1554C45.4503 15.1318 45.4739 15.1083 45.5093 15.0847C46.6287 14.0363 46.228 12.6934 45.1793 11.5626C44.1306 10.4435 39.2051 8.37024 39.2051 8.37024C39.2051 8.37024 40.949 13.412 42.0095 14.5428Z",
    fill: "url(#paint27_radial_578_447492)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0095 14.5428C43.0347 15.6383 44.3191 16.1331 45.4268 15.1554L39.2051 8.37024C39.2169 8.3938 39.4525 9.08883 39.806 9.98409C39.9238 10.3021 40.0653 10.6437 40.2067 10.9971C40.6545 12.1162 41.1965 13.3178 41.6678 14.0481C41.7857 14.2601 41.8917 14.4132 42.0095 14.5428Z",
    fill: "url(#paint28_radial_578_447492)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3162 14.2486C43.1646 15.1438 44.2133 15.5326 45.1088 14.6962C46.0044 13.8481 45.698 12.7761 44.8496 11.8808C44.4961 11.5157 43.6359 11.0209 42.7404 10.5615C41.4442 9.90187 40.0537 9.31287 40.0537 9.31287C40.0537 9.31287 40.2776 9.94896 40.5958 10.7735C41.0907 12.0104 41.8095 13.7067 42.3162 14.2486Z",
    fill: "url(#paint29_radial_578_447492)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1514 13.9893C42.1985 14.06 42.2456 14.1306 42.2927 14.2013C42.2574 14.1542 42.2103 14.0835 42.1514 13.9893Z",
    fill: "url(#paint30_radial_578_447492)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1479 9.37177C40.1479 9.37177 41.5619 13.4122 42.3985 14.3075C42.5871 14.496 42.7639 14.6609 42.9642 14.8023C42.7403 14.6491 42.5164 14.4606 42.3161 14.2486C41.4677 13.3533 40.0654 9.31287 40.0654 9.31287C40.0654 9.31287 43.0703 10.5851 44.39 11.5039C43.0231 10.5733 40.1479 9.37177 40.1479 9.37177Z",
    fill: "url(#paint31_radial_578_447492)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0616 14.6843C45.9572 13.8361 45.6508 12.7642 44.8024 11.8689C44.0247 11.0443 40.6075 9.56009 40.0772 9.33628C40.0654 9.31272 40.0654 9.3009 40.0654 9.3009C40.0654 9.3009 44.0011 10.9619 44.8496 11.8571C45.698 12.7524 46.0161 13.8243 45.1088 14.6725C44.7906 14.967 44.4607 15.1083 44.119 15.1319C44.4371 15.1083 44.7553 14.967 45.0616 14.6843Z",
    fill: "url(#paint32_radial_578_447492)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1934 8.3822C39.1934 8.3822 39.7236 8.81803 40.0535 9.301C40.0535 9.31278 39.594 8.86517 39.1934 8.3822Z",
    fill: "url(#paint33_radial_578_447492)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9474 10.0432C40.0653 10.3612 40.2066 10.7028 40.348 11.0562C40.7958 12.1753 41.3378 13.3768 41.8092 14.1072C41.927 14.2957 42.0449 14.4606 42.1627 14.5784C42.6105 15.0613 43.1172 15.4265 43.6474 15.6032C43.0818 15.45 42.528 15.0613 42.0213 14.5312C41.9035 14.4134 41.7974 14.2485 41.6678 14.06C41.1965 13.3297 40.6545 12.1164 40.2067 11.0091C40.0653 10.6557 39.9238 10.314 39.806 9.996C39.4525 9.07717 39.2169 8.40576 39.2051 8.3822L39.4172 8.6178C39.5114 8.88873 39.7 9.40705 39.9474 10.0432Z",
    fill: "url(#paint34_radial_578_447492)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1955 11.0091C40.3959 10.856 40.5255 10.8089 40.5255 10.8089L40.1012 9.68982C39.9834 9.79584 39.8892 9.90182 39.7949 10.0078C39.9245 10.3141 40.0541 10.6675 40.1955 11.0091Z",
    fill: "url(#paint35_radial_578_447492)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.85 14.8575H41.2314L47.0408 6L48.8789 8.80387L50.1751 10.784L52.85 14.8575Z",
    fill: "url(#paint36_radial_578_447492)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0408 6V7.05806L45.285 9.74101L44.3895 11.1014L42.2802 14.3285L41.2314 14.8575L43.8474 10.8746L44.7547 9.49162L47.0408 6Z",
    fill: "url(#paint37_radial_578_447492)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2314 14.8577L42.2802 14.3286H51.8013L52.85 14.8577H41.2314Z",
    fill: "url(#paint38_radial_578_447492)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1754 10.7839L48.1958 11.9629L47.0527 10.3078L48.8792 8.80383L50.1754 10.7839Z",
    fill: "url(#paint39_radial_578_447492)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2286 8.06327L45.3448 9.42364L44.791 9.19691L45.6983 7.82141L46.2286 8.06327Z",
    fill: "url(#paint40_radial_578_447492)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8014 14.3287H42.2803L44.1185 11.5097L47.0409 7.05823L48.9969 10.036L51.8014 14.3287Z",
    fill: "url(#paint41_radial_578_447492)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7715 8.22192C47.7715 8.22192 49.268 10.7235 51.5422 13.8448C51.5422 13.8448 49.7747 10.8898 47.7715 8.22192Z",
    fill: "url(#paint42_radial_578_447492)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5929 7.67761C46.5929 7.67761 44.7547 10.1641 42.834 13.4289C42.834 13.4289 44.3187 11.2448 46.5929 7.67761Z",
    fill: "url(#paint43_radial_578_447492)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.041 6C47.041 6 46.9114 6.46101 47.041 7.05806C47.041 7.05806 47.1588 6.77087 47.041 6Z",
    fill: "url(#paint44_radial_578_447492)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9965 10.0359C47.0404 10.497 45.3672 11.0411 44.1299 11.5021L47.0522 7.05823L48.9965 10.0359Z",
    fill: "url(#paint45_radial_578_447492)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9876 26.531V28.1095L75.2388 31.1605C73.7188 32.15 71.9513 32.6565 70.1366 32.6565H67.1318L64.3509 35.4365C64.3273 35.4601 64.3037 35.4837 64.2684 35.519C63.9502 35.8017 63.585 36.0137 63.1843 36.1197C63.1372 36.1315 63.1018 36.1433 63.0665 36.1433C63.0194 36.1551 62.9604 36.1668 62.9133 36.1786C62.7719 36.2022 62.6305 36.214 62.4773 36.214H55.0654V27.1554L67.1318 26.8491L79.9876 26.531Z",
    fill: "url(#paint46_radial_578_447492)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1318 26.8491L79.9876 26.531V28.1095L75.2389 31.1605C73.7188 32.15 71.9513 32.6565 70.1366 32.6565H67.1318V26.8491Z",
    fill: "url(#paint47_radial_578_447492)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7755 26.531L75.2035 29.476C73.6834 30.4655 71.9159 30.972 70.1012 30.972H67.0964L64.3155 33.752C63.8206 34.2468 63.1372 34.5295 62.4419 34.5295H55.0654V34.6355H62.4773C63.1843 34.6355 63.856 34.3528 64.3509 33.8581L67.1318 31.078H70.1366C71.9513 31.078 73.7188 30.5597 75.2388 29.582L79.9876 26.531H79.7755Z",
    fill: "url(#paint48_radial_578_447492)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2809 33.4102V35.5188C63.9627 35.8015 63.5974 36.0135 63.1968 36.1195C63.1496 36.1313 63.1143 36.1431 63.0789 36.1431C63.0318 36.1549 62.9729 36.1666 62.9258 36.1784V33.4102H64.2809Z",
    fill: "url(#paint49_radial_578_447492)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9876 26.531L75.2388 29.582C73.7188 30.5715 71.9513 31.078 70.1366 31.078H67.1318L64.3509 33.8581C63.856 34.3528 63.1725 34.6355 62.4773 34.6355H55.0654V27.1436L79.5162 26.531H79.9876Z",
    fill: "url(#paint50_radial_578_447492)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0654 27.1552L79.5516 26.6722L75.2035 29.4758C73.6834 30.4653 71.9159 30.9718 70.1012 30.9718H67.0964L64.3155 33.7519C63.8206 34.2466 63.1372 34.5293 62.4419 34.5293H55.0654V34.6353H62.4773C63.1843 34.6353 63.856 34.3526 64.3509 33.8579L67.1318 31.0778H70.1366C71.9513 31.0778 73.7188 30.5595 75.2388 29.5818L77.5248 28.1093L79.8697 26.7546L79.9994 28.0976V26.519L55.0654 27.1552Z",
    fill: "url(#paint51_radial_578_447492)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6859 34.5057C52.6738 34.5178 52.6738 34.5178 52.6738 34.5178C52.6738 34.5057 52.6738 34.5057 52.6859 34.5057Z",
    fill: "url(#paint52_radial_578_447492)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0299 27.8148L75.0031 29.0871C73.7894 29.841 72.4107 30.265 70.9849 30.2886L55.0771 30.6302V28.0858C60.474 28.0033 77.0888 27.7441 77.0299 27.8148Z",
    fill: "url(#paint53_radial_578_447492)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0498 30.3591L64.8699 32.6327H55.502V30.5829L67.0498 30.3591Z",
    fill: "url(#paint54_radial_578_447492)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9768 26.4838V28.0622L75.228 31.1132C73.708 32.1027 71.9405 32.6092 70.1258 32.6092H67.121L64.3401 35.3893C64.3165 35.4128 64.2929 35.4364 64.2576 35.4717C63.9394 35.7544 63.5742 35.9665 63.1735 36.0725C63.1264 36.0843 63.091 36.0961 63.0557 36.0961C63.0086 36.1078 62.9496 36.1196 62.9025 36.1314C62.7611 36.1549 62.6197 36.1668 62.4665 36.1668H55.0547V27.1081L67.121 26.8018L79.9768 26.4838Z",
    fill: "url(#paint55_radial_578_447492)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2704 26.2366V28.1331L79.5045 28.675H79.0685L79.3984 28.4747V27.4734L78.1965 27.7326L78.7739 26.8138L55.0537 27.2732L54.877 26.8491L80.2704 26.2366Z",
    fill: "url(#paint56_radial_578_447492)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7744 26.8137L78.9747 26.531L54.9717 27.1082L55.0542 27.2732L78.7744 26.8137Z",
    fill: "url(#paint57_radial_578_447492)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2819 26.9551V26.2366L78.208 27.7444L79.3981 27.4734V28.4747L79.0682 28.675H79.5042L80.2701 28.1331L80.2819 26.9551Z",
    fill: "url(#paint58_radial_578_447492)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5053 28.6748V27.4614L79.3992 27.4732V28.4745L79.0693 28.6748H79.5053Z",
    fill: "url(#paint59_radial_578_447492)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0112 26.3308L78.2083 27.7444L80.1643 26.4369L80.2704 28.1331L80.2822 26.2366L54.877 26.8491L80.0112 26.3308Z",
    fill: "url(#paint60_radial_578_447492)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4814 27.4614L79.4932 28.6748C79.505 28.6748 79.6228 27.9208 79.4814 27.4614Z",
    fill: "url(#paint61_radial_578_447492)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1914 26.8021C67.1914 26.8021 72.4468 26.6017 78.6921 26.531C78.6921 26.531 72.6 26.7431 67.1914 26.8021Z",
    fill: "url(#paint62_radial_578_447492)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.877 27.0845C54.877 27.0845 60.1324 26.8842 66.3776 26.8135C66.3894 26.8135 60.2856 27.0138 54.877 27.0845Z",
    fill: "url(#paint63_radial_578_447492)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5752 27.4612V28.3094C79.5752 28.3094 79.7873 27.8618 80.2233 27.7675L80.188 27.1196L79.5752 27.4612Z",
    fill: "url(#paint64_radial_578_447492)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M55.09 27.4615L78.4803 26.9903L78.2093 27.7442L78.7749 26.8136L55.0547 27.2731L55.09 27.4615Z",
    fill: "url(#paint65_radial_578_447492)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.208 27.744L79.2685 27.7204L79.2449 28.5332L79.3981 28.4743V27.473L78.208 27.744Z",
    fill: "url(#paint66_radial_578_447492)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2949 26.5314V28.1098L19.0437 31.1609C20.5638 32.1504 22.3313 32.6568 24.146 32.6568H27.1508L29.9317 35.4369C29.9552 35.4604 29.9788 35.484 30.0142 35.5194C30.3323 35.8021 30.6976 36.0141 31.0982 36.1201C31.1454 36.1319 31.1807 36.1437 31.2161 36.1437C31.2632 36.1555 31.3222 36.1672 31.3693 36.179C31.5107 36.2025 31.6521 36.2144 31.8052 36.2144H39.2171V27.1557L27.1508 26.8494L14.2949 26.5314Z",
    fill: "url(#paint67_radial_578_447492)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1507 26.8494L14.2949 26.5314V28.1098L19.0437 31.1609C20.5638 32.1504 22.3313 32.6569 24.146 32.6569H27.1507V26.8494Z",
    fill: "url(#paint68_radial_578_447492)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5071 26.5314L19.079 29.4763C20.5991 30.4658 22.3667 30.9724 24.1813 30.9724H27.1861L29.967 33.7524C30.4619 34.2472 31.1454 34.5298 31.8406 34.5298H39.2171V34.6359H31.8052C31.0982 34.6359 30.4266 34.3532 29.9317 33.8584L27.1508 31.0784H24.146C22.3313 31.0784 20.5638 30.56 19.0437 29.5823L14.2949 26.5314H14.5071Z",
    fill: "url(#paint69_radial_578_447492)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30.002 33.4104V35.519C30.3201 35.8017 30.6854 36.0137 31.086 36.1198C31.1331 36.1315 31.1685 36.1433 31.2038 36.1433C31.251 36.1551 31.3099 36.1669 31.3571 36.1786V33.4104H30.002Z",
    fill: "url(#paint70_radial_578_447492)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2949 26.5314L19.0437 29.5823C20.5638 30.5718 22.3313 31.0784 24.146 31.0784H27.1508L29.9317 33.8584C30.4266 34.3532 31.11 34.6359 31.8052 34.6359H39.2171V27.1439L14.7663 26.5314H14.2949Z",
    fill: "url(#paint71_radial_578_447492)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2171 27.1554L14.731 26.6725L19.0791 29.476C20.5991 30.4655 22.3667 30.9721 24.1814 30.9721H27.1862L29.967 33.7521C30.4619 34.2469 31.1454 34.5295 31.8406 34.5295H39.2171V34.6356H31.8053C31.0982 34.6356 30.4266 34.3529 29.9317 33.8581L27.1508 31.0781H24.146C22.3313 31.0781 20.5638 30.5597 19.0437 29.582L16.7577 28.1096L14.4128 26.7549L14.2832 28.0978V26.5193L39.2171 27.1554Z",
    fill: "url(#paint72_radial_578_447492)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5977 34.506C41.609 34.5173 41.609 34.5173 41.609 34.5173C41.6203 34.506 41.609 34.506 41.5977 34.506Z",
    fill: "url(#paint73_radial_578_447492)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2521 27.8149L19.2789 29.0872C20.4926 29.8411 21.8713 30.2651 23.2971 30.2887L39.2048 30.6303V28.0859C33.808 28.0034 17.1932 27.7443 17.2521 27.8149Z",
    fill: "url(#paint74_radial_578_447492)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2324 30.3594L29.4124 32.6329H38.7803V30.5832L27.2324 30.3594Z",
    fill: "url(#paint75_radial_578_447492)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3174 26.4841V28.0626L19.0661 31.1136C20.5862 32.1031 22.3538 32.6096 24.1684 32.6096H27.1732L29.9541 35.3896C29.9777 35.4132 30.0012 35.4367 30.0366 35.4721C30.3547 35.7548 30.7201 35.9668 31.1207 36.0728C31.1678 36.0846 31.2032 36.0964 31.2385 36.0964C31.2857 36.1082 31.3446 36.12 31.3917 36.1317C31.5331 36.1553 31.6745 36.1671 31.8277 36.1671H39.2395V27.1084L27.1732 26.8022L14.3174 26.4841Z",
    fill: "url(#paint76_radial_578_447492)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 26.2367V28.1332L14.7776 28.6751H15.2137L14.8837 28.4748V27.4736L16.0856 27.7327L15.5082 26.8139L39.2284 27.2733L39.417 26.8493L14.0117 26.2367Z",
    fill: "url(#paint77_radial_578_447492)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5079 26.8141L15.3193 26.5314L39.3224 27.1086L39.2281 27.2735L15.5079 26.8141Z",
    fill: "url(#paint78_radial_578_447492)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.9552V26.2366L16.0739 27.7444L14.8838 27.4735V28.4747L15.2137 28.675H14.7777L14.0118 28.1331L14 26.9552Z",
    fill: "url(#paint79_radial_578_447492)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7773 28.6749L14.7891 27.4615L14.8834 27.4733V28.4746L15.2134 28.6749H14.7773Z",
    fill: "url(#paint80_radial_578_447492)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2711 26.3308L16.0739 27.7444L14.1178 26.4369L14.0118 28.1331L14 26.2366L39.4171 26.8491L14.2711 26.3308Z",
    fill: "url(#paint81_radial_578_447492)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8014 27.4615L14.7896 28.6749C14.7896 28.6749 14.66 27.921 14.8014 27.4615Z",
    fill: "url(#paint82_radial_578_447492)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1033 26.8024C27.1033 26.8024 21.8478 26.6021 15.6026 26.5314C15.5908 26.5314 21.6829 26.7435 27.1033 26.8024Z",
    fill: "url(#paint83_radial_578_447492)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4168 27.085C39.4168 27.085 34.1613 26.8847 27.916 26.814C27.9042 26.814 33.9963 27.0143 39.4168 27.085Z",
    fill: "url(#paint84_radial_578_447492)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7184 27.4615V28.3096C14.7184 28.3096 14.5063 27.862 14.0703 27.7678L14.1057 27.1199L14.7184 27.4615Z",
    fill: "url(#paint85_radial_578_447492)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1927 27.4619L15.8024 26.9907L16.0734 27.7446L15.5078 26.814L39.228 27.2734L39.1927 27.4619Z",
    fill: "url(#paint86_radial_578_447492)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0739 27.7441L15.0252 27.7205L15.037 28.5333L14.8838 28.4744V27.4731L16.0739 27.7441Z",
    fill: "url(#paint87_radial_578_447492)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8262 16.0472L53.0501 16.6951L55.3125 23.28L66.4479 19.4634C70.4661 18.0733 73.7773 15.1637 75.6391 11.3353L77.0413 8.44928L76.8174 7.80139L52.8262 16.0472Z",
    fill: "url(#paint88_radial_578_447492)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8262 16.0472L76.8174 7.80139L75.4152 10.6874C73.5534 14.5041 70.2422 17.4255 66.2241 18.8155L55.0886 22.6321L52.8262 16.0472Z",
    fill: "url(#paint89_radial_578_447492)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8262 16.0472L76.8174 7.80139L75.4152 10.6874C73.5534 14.5041 70.2422 17.4255 66.2241 18.8155L55.0886 22.6321L52.8262 16.0472Z",
    fill: "url(#paint90_radial_578_447492)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8174 7.80139L52.8262 16.0472L52.8851 16.2121L76.4521 8.11947L75.0499 11.0055C74.1072 12.9374 72.7993 14.6337 71.1967 16.0237C72.9525 14.5748 74.39 12.7725 75.4152 10.6874L76.7585 7.97809L77.0413 8.46107L76.8174 7.80139Z",
    fill: "url(#paint91_radial_578_447492)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M66.79 18.5328L55.0654 22.5615L55.089 22.6321L66.2244 18.8155C66.8608 18.6035 67.4735 18.3325 68.0745 18.0498C67.6503 18.2147 67.226 18.3796 66.79 18.5328Z",
    fill: "url(#paint92_radial_578_447492)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9902 18.5328C66.9902 18.5328 70.5135 17.343 73.2473 13.9976C73.2473 13.9976 71.3148 16.5184 66.9902 18.5328Z",
    fill: "url(#paint93_radial_578_447492)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M65.046 19.2043C66.731 15.7646 69.9007 11.8773 72.0453 9.43884L65.4584 11.7006C63.9265 14.9754 60.5682 18.9922 58.2822 21.5249L65.046 19.2043Z",
    fill: "url(#paint94_radial_578_447492)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6467 10.9351L70.7966 13.3499C69.2176 15.3996 67.1202 16.9309 64.7399 17.7437L54.6886 21.1952L53.4277 17.5317L72.6467 10.9351Z",
    fill: "url(#paint95_radial_578_447492)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7413 10.8638L70.8206 13.149C69.1827 15.0927 67.0499 16.5652 64.6343 17.3898L54.5005 20.8766L53.3457 17.5193L72.7413 10.8638Z",
    fill: "url(#paint96_linear_578_447492)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4936 11.1704L70.6082 13.4557C69.0057 15.3876 66.9082 16.8483 64.5279 17.6611L54.5591 21.089L53.4043 17.7318L72.4936 11.1704Z",
    fill: "url(#paint97_radial_578_447492)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2646 17.6612L71.7043 11.6653L71.5275 11.8773C70.2549 13.3851 68.6052 14.5277 66.7434 15.1638L54.7713 19.2868L54.2646 17.6612Z",
    fill: "url(#paint98_radial_578_447492)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9161 12.1957C71.9161 12.1957 70.3843 14.2217 69.2295 15.2112C69.2295 15.2112 70.9499 14.2335 71.869 15.0346C71.869 15.0346 74.261 12.3606 74.9916 10.7821C74.9916 10.7939 73.6247 12.0072 71.9161 12.1957Z",
    fill: "url(#paint99_radial_578_447492)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8262 16.0472L53.0501 16.6951L55.3125 23.28L66.4479 19.4634C70.4661 18.0733 73.7773 15.1637 75.6391 11.3353L77.0413 8.44928L76.8174 7.80139L52.8262 16.0472Z",
    fill: "url(#paint100_radial_578_447492)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1992 18.2855L50.3053 18.9688L51.3894 25.8482L63.0079 24.0105C67.2029 23.3508 70.9736 21.042 73.4717 17.6023L75.357 15.0108L75.251 14.3275L50.1992 18.2855Z",
    fill: "url(#paint101_radial_578_447492)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1992 18.2855L75.251 14.3275L73.3656 16.9191C70.8675 20.3588 67.1085 22.6676 62.9018 23.3273L51.2833 25.1649L50.1992 18.2855Z",
    fill: "url(#paint102_radial_578_447492)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1992 18.2855L75.251 14.3275L73.3656 16.9191C70.8675 20.3588 67.1085 22.6676 62.9018 23.3273L51.2833 25.1649L50.1992 18.2855Z",
    fill: "url(#paint103_radial_578_447492)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M75.251 14.3275L50.1992 18.2855L50.2228 18.4622L74.8386 14.5749L72.9532 17.1665C71.6924 18.9099 70.1016 20.3588 68.2987 21.4543C70.2783 20.3352 72.0105 18.8038 73.3774 16.9309L75.1685 14.4925L75.3688 15.0226L75.251 14.3275Z",
    fill: "url(#paint104_radial_578_447492)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5145 23.1504L51.2715 25.0822L51.2833 25.1529L62.9018 23.3153C63.5617 23.2093 64.2215 23.0679 64.8579 22.8794C64.4219 22.9854 63.9741 23.0797 63.5145 23.1504Z",
    fill: "url(#paint105_radial_578_447492)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7148 23.1856C63.7148 23.1856 67.3795 22.632 70.6671 19.7931C70.6553 19.8049 68.3222 21.9488 63.7148 23.1856Z",
    fill: "url(#paint106_radial_578_447492)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6882 23.5037C63.9388 20.4057 67.7449 17.1191 70.2784 15.1047L63.3968 16.1885C61.3229 19.1452 57.3283 22.5142 54.6299 24.6228L61.6882 23.5037Z",
    fill: "url(#paint107_radial_578_447492)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5968 16.6837L68.3461 18.7452C66.4372 20.5004 64.104 21.6313 61.6177 22.0318L51.1186 23.6927L50.5059 19.876L70.5968 16.6837Z",
    fill: "url(#paint108_radial_578_447492)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7021 16.6245L68.4162 18.5446C66.4719 20.182 64.1034 21.254 61.5935 21.6545L51.0001 23.3272L50.4463 19.8286L70.7021 16.6245Z",
    fill: "url(#paint109_linear_578_447492)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4075 16.8954L68.1568 18.8155C66.2479 20.4411 63.9265 21.5131 61.4402 21.9018L51.0236 23.551L50.4697 20.0523L70.4075 16.8954Z",
    fill: "url(#paint110_radial_578_447492)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3301 20.1231L69.5474 17.2371L69.3353 17.4138C67.8152 18.6742 66.0005 19.5105 64.0445 19.8168L51.5422 21.7959L51.3301 20.1231Z",
    fill: "url(#paint111_radial_578_447492)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6541 17.8023C69.6541 17.8023 67.7923 19.534 66.4844 20.3232C66.4844 20.3232 68.3461 19.6636 69.1121 20.6059C69.1121 20.6059 71.9283 18.3913 72.9299 16.9542C72.9299 16.9424 71.3863 17.9083 69.6541 17.8023Z",
    fill: "url(#paint112_radial_578_447492)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1992 18.2855L50.3053 18.9688L51.3894 25.8482L63.0079 24.0105C67.2029 23.3508 70.9736 21.042 73.4717 17.6023L75.357 15.0108L75.251 14.3275L50.1992 18.2855Z",
    fill: "url(#paint113_radial_578_447492)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8684 20.6764V21.3243L48.833 27.7796L59.7563 27.8385C63.7038 27.862 67.4981 26.3189 70.3026 23.5506L72.4236 21.4656V20.8177L48.8684 20.6764Z",
    fill: "url(#paint114_radial_578_447492)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8675 20.6764L72.4109 20.8177L70.2899 22.9028C67.4854 25.6828 63.6911 27.2259 59.7437 27.1906L48.8203 27.1317L48.8675 20.6764Z",
    fill: "url(#paint115_radial_578_447492)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8675 20.6764L72.4109 20.8177L70.2899 22.9028C67.4854 25.6828 63.6911 27.2259 59.7437 27.1906L48.8203 27.1317L48.8675 20.6764Z",
    fill: "url(#paint116_radial_578_447492)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4106 20.8061L48.8672 20.6648V20.8297L71.9982 20.9711L69.8772 23.0561C68.4632 24.4579 66.7899 25.5416 64.9634 26.272C66.9431 25.5534 68.7577 24.399 70.2896 22.8912L72.2928 20.9357L72.3988 21.454L72.4106 20.8061Z",
    fill: "url(#paint117_radial_578_447492)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3445 27.1316L48.8438 27.0609V27.1316L59.7671 27.1905C60.3916 27.1905 61.0161 27.1552 61.6171 27.0845C61.1811 27.1199 60.7569 27.1316 60.3445 27.1316Z",
    fill: "url(#paint118_radial_578_447492)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5098 27.1908C60.5098 27.1908 63.9623 27.2379 67.3795 25.1411C67.3913 25.1411 64.9168 26.7431 60.5098 27.1908Z",
    fill: "url(#paint119_radial_578_447492)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6125 27.1787C61.146 24.6814 65.117 22.243 67.7448 20.7705L61.2874 20.7352C58.9425 23.1383 54.7711 25.6238 51.9902 27.1434L58.6125 27.1787Z",
    fill: "url(#paint120_radial_578_447492)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7923 22.2781L65.4238 23.8331C63.4089 25.1524 61.0993 25.8356 58.7661 25.8238L48.9033 25.7649L48.9151 22.1721L67.7923 22.2781Z",
    fill: "url(#paint121_radial_578_447492)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8979 22.2314L65.5058 23.645C63.479 24.8465 61.1459 25.4826 58.7774 25.4591L48.8203 25.4002L48.8321 22.1136L67.8979 22.2314Z",
    fill: "url(#paint122_linear_578_447492)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5914 22.4436L65.2347 23.8572C63.2433 25.0587 60.9455 25.6948 58.6241 25.6713L48.832 25.6124L48.8438 22.3258L67.5914 22.4436Z",
    fill: "url(#paint123_radial_578_447492)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6214 22.5143L66.7428 22.6203L66.5308 22.7499C64.9518 23.6805 63.1607 24.1635 61.3224 24.1635L49.5625 24.0928L49.6214 22.5143Z",
    fill: "url(#paint124_radial_578_447492)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7671 23.1503C66.7671 23.1503 64.7992 24.4579 63.4795 24.9762C63.4795 24.9762 65.2824 24.6464 65.8362 25.6241C65.8362 25.6241 68.7467 24.0103 69.8779 22.8558C69.8897 22.8676 68.3225 23.5155 66.7671 23.1503Z",
    fill: "url(#paint125_radial_578_447492)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8684 20.6764V21.3243L48.833 27.7796L59.7563 27.8385C63.7038 27.862 67.4981 26.3189 70.3026 23.5506L72.4236 21.4656V20.8177L48.8684 20.6764Z",
    fill: "url(#paint126_radial_578_447492)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9368 16.047L40.7129 16.6949L38.4505 23.2797L27.3151 19.4631C23.2969 18.0731 19.9857 15.1635 18.1239 11.3351L16.7217 8.44903L16.9456 7.80115L40.9368 16.047Z",
    fill: "url(#paint127_radial_578_447492)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9375 16.0471L16.9463 7.80127L18.3486 10.6873C20.2104 14.504 23.5215 17.4253 27.5397 18.8154L38.6751 22.632L40.9375 16.0471Z",
    fill: "url(#paint128_radial_578_447492)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9375 16.0471L16.9463 7.80127L18.3486 10.6873C20.2104 14.504 23.5215 17.4253 27.5397 18.8154L38.6751 22.632L40.9375 16.0471Z",
    fill: "url(#paint129_radial_578_447492)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9456 7.80115L40.9368 16.047L40.8779 16.2119L17.3109 8.11922L18.7131 11.0053C19.6558 12.9371 20.9638 14.6334 22.5663 16.0235C20.8106 14.5745 19.373 12.7722 18.3478 10.6872L17.0045 7.97784L16.7217 8.46083L16.9456 7.80115Z",
    fill: "url(#paint130_radial_578_447492)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9738 18.5325L38.6984 22.5612L38.6749 22.6319L27.5395 18.8152C26.9032 18.6032 26.2904 18.3323 25.6895 18.0496C26.1137 18.2145 26.5379 18.3794 26.9738 18.5325Z",
    fill: "url(#paint131_radial_578_447492)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7737 18.5325C26.7737 18.5325 23.2504 17.3428 20.5166 13.9973C20.5166 13.9973 22.4609 16.5182 26.7737 18.5325Z",
    fill: "url(#paint132_radial_578_447492)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7172 19.2041C27.0322 15.7644 23.8624 11.877 21.7178 9.4386L28.3048 11.7003C29.8367 14.9751 33.195 18.992 35.481 21.5247L28.7172 19.2041Z",
    fill: "url(#paint133_radial_578_447492)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1289 10.9348L22.9789 13.3497C24.5579 15.3993 26.6554 16.9307 29.0357 17.7435L39.087 21.195L40.3478 17.5315L21.1289 10.9348Z",
    fill: "url(#paint134_radial_578_447492)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0225 10.8635L22.9432 13.1488C24.5811 15.0924 26.7139 16.5649 29.1296 17.3895L39.2634 20.8763L40.4181 17.5191L21.0225 10.8635Z",
    fill: "url(#paint135_linear_578_447492)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2695 11.1702L23.1549 13.4554C24.7575 15.3873 26.8549 16.848 29.2352 17.6608L39.2041 21.0887L40.3588 17.7315L21.2695 11.1702Z",
    fill: "url(#paint136_radial_578_447492)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5109 17.6609L22.0713 11.665L22.248 11.8771C23.5207 13.3849 25.1704 14.5275 27.0322 15.1636L39.0042 19.2865L39.5109 17.6609Z",
    fill: "url(#paint137_radial_578_447492)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M21.848 12.1954C21.848 12.1954 23.3799 14.2215 24.5346 15.211C24.5346 15.211 22.8142 14.2333 21.8951 15.0343C21.8951 15.0343 19.503 12.3604 18.7725 10.7819C18.7842 10.7936 20.1394 12.007 21.848 12.1954Z",
    fill: "url(#paint138_radial_578_447492)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9368 16.047L40.7129 16.6949L38.4505 23.2797L27.3151 19.4631C23.2969 18.0731 19.9857 15.1635 18.1239 11.3351L16.7217 8.44903L16.9456 7.80115L40.9368 16.047Z",
    fill: "url(#paint139_radial_578_447492)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5768 18.2856L43.4707 18.9689L42.3867 25.8483L30.7681 24.0106C26.5732 23.351 22.8024 21.0421 20.3043 17.6024L18.4189 15.0109L18.525 14.3276L43.5768 18.2856Z",
    fill: "url(#paint140_radial_578_447492)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5771 18.2856L18.5254 14.3276L20.4108 16.9192C22.9089 20.3589 26.6678 22.6678 30.8745 23.3274L42.493 25.165L43.5771 18.2856Z",
    fill: "url(#paint141_radial_578_447492)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5771 18.2856L18.5254 14.3276L20.4108 16.9192C22.9089 20.3589 26.6678 22.6678 30.8745 23.3274L42.493 25.165L43.5771 18.2856Z",
    fill: "url(#paint142_radial_578_447492)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5133 14.3275L43.5651 18.2855L43.5415 18.4622L18.9258 14.5749L20.8111 17.1665C22.072 18.9099 23.6627 20.3588 25.4656 21.4543C23.486 20.3352 21.7538 18.8038 20.3869 16.9309L18.5958 14.4925L18.3955 15.0226L18.5133 14.3275Z",
    fill: "url(#paint143_radial_578_447492)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2496 23.1504L42.4927 25.0822L42.4809 25.1529L30.8623 23.3153C30.2024 23.2093 29.5426 23.0679 28.9062 22.8794C29.354 22.9854 29.8018 23.0797 30.2496 23.1504Z",
    fill: "url(#paint144_radial_578_447492)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0499 23.1856C30.0499 23.1856 26.3853 22.632 23.0977 19.7931C23.0977 19.8049 25.4544 21.9488 30.0499 23.1856Z",
    fill: "url(#paint145_radial_578_447492)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0766 23.5037C29.8259 20.4057 26.0198 17.1191 23.4863 15.1047L30.3679 16.1885C32.4418 19.1452 36.4364 22.5142 39.1349 24.6228L32.0766 23.5037Z",
    fill: "url(#paint146_radial_578_447492)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23.168 16.6837L25.4186 18.7452C27.3276 20.5004 29.6607 21.6313 32.147 22.0318L42.6461 23.6927L43.2589 19.876L23.168 16.6837Z",
    fill: "url(#paint147_radial_578_447492)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 16.6245L25.3475 18.5446C27.2918 20.182 29.6603 21.254 32.1702 21.6545L42.7635 23.3272L43.3174 19.8286L23.0615 16.6245Z",
    fill: "url(#paint148_linear_578_447492)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3682 16.8954L25.6188 18.8155C27.5278 20.4411 29.8491 21.5131 32.3354 21.9018L42.7521 23.551L43.3059 20.0523L23.3682 16.8954Z",
    fill: "url(#paint149_radial_578_447492)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4458 20.1231L24.2285 17.2371L24.4406 17.4138C25.9607 18.6742 27.7753 19.5105 29.7314 19.8168L42.2337 21.7959L42.4458 20.1231Z",
    fill: "url(#paint150_radial_578_447492)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M24.099 17.8024C24.099 17.8024 25.9608 19.5341 27.2688 20.3234C27.2688 20.3234 25.407 19.6637 24.6411 20.6061C24.6411 20.6061 21.8248 18.3915 20.8232 16.9543C20.835 16.9426 22.3904 17.9085 24.099 17.8024Z",
    fill: "url(#paint151_radial_578_447492)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5768 18.2856L43.4707 18.9689L42.3867 25.8483L30.7681 24.0106C26.5732 23.351 22.8024 21.0421 20.3043 17.6024L18.4189 15.0109L18.525 14.3276L43.5768 18.2856Z",
    fill: "url(#paint152_radial_578_447492)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8961 20.6764V21.3243L44.9314 27.7796L34.0081 27.8385C30.0606 27.862 26.2663 26.3189 23.4619 23.5506L21.3408 21.4656V20.8177L44.8961 20.6764Z",
    fill: "url(#paint153_radial_578_447492)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M44.896 20.6763L21.3525 20.8176L23.4736 22.9026C26.278 25.6827 30.0723 27.2258 34.0198 27.1905L44.9431 27.1316L44.896 20.6763Z",
    fill: "url(#paint154_radial_578_447492)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M44.896 20.6763L21.3525 20.8176L23.4736 22.9026C26.278 25.6827 30.0723 27.2258 34.0198 27.1905L44.9431 27.1316L44.896 20.6763Z",
    fill: "url(#paint155_radial_578_447492)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3525 20.806L44.896 20.6647V20.8296L21.765 20.971L23.886 23.0559C25.3 24.4577 26.9732 25.5415 28.7997 26.2719C26.8201 25.5533 25.0054 24.3988 23.4736 22.891L21.4704 20.9356L21.3643 21.4539L21.3525 20.806Z",
    fill: "url(#paint156_radial_578_447492)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4309 27.1315L44.9315 27.0608V27.1315L34.0082 27.1904C33.3837 27.1904 32.7592 27.1551 32.1582 27.0844C32.5824 27.1197 33.0067 27.1315 33.4309 27.1315Z",
    fill: "url(#paint157_radial_578_447492)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2536 27.1907C33.2536 27.1907 29.801 27.2378 26.3838 25.141C26.3838 25.141 28.8584 26.743 33.2536 27.1907Z",
    fill: "url(#paint158_radial_578_447492)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1625 27.1786C32.629 24.6813 28.658 22.2429 26.0303 20.7704L32.4877 20.7351C34.8326 23.1382 39.0039 25.6237 41.7849 27.1433L35.1625 27.1786Z",
    fill: "url(#paint159_radial_578_447492)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9707 22.278L28.3392 23.833C30.3542 25.1523 32.6638 25.8355 34.9969 25.8237L44.8597 25.7648L44.8479 22.172L25.9707 22.278Z",
    fill: "url(#paint160_radial_578_447492)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8652 22.2313L28.2573 23.6449C30.284 24.8464 32.6172 25.4825 34.9857 25.459L44.9427 25.4001L44.9309 22.1135L25.8652 22.2313Z",
    fill: "url(#paint161_linear_578_447492)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1719 22.4435L28.5286 23.8571C30.52 25.0586 32.8178 25.6947 35.1391 25.6711L44.9312 25.6122L44.9195 22.3257L26.1719 22.4435Z",
    fill: "url(#paint162_radial_578_447492)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M44.141 22.5142L27.0195 22.6202L27.2317 22.7498C28.8107 23.6804 30.6017 24.1633 32.4399 24.1633L44.1999 24.0927L44.141 22.5142Z",
    fill: "url(#paint163_radial_578_447492)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9966 23.1503C26.9966 23.1503 28.9645 24.4579 30.2842 24.9762C30.2842 24.9762 28.4814 24.6464 27.9275 25.6241C27.9275 25.6241 25.017 24.0103 23.8858 22.8558C23.874 22.8676 25.4412 23.5155 26.9966 23.1503Z",
    fill: "url(#paint164_radial_578_447492)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8961 20.6764V21.3243L44.9314 27.7796L34.0081 27.8385C30.0606 27.862 26.2663 26.3189 23.4619 23.5506L21.3408 21.4656V20.8177L44.8961 20.6764Z",
    fill: "url(#paint165_radial_578_447492)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1729 19.2748V32.3975C34.1729 33.0454 34.5146 33.6462 35.0684 33.9878L45.9328 40.4902C46.522 40.8436 47.2525 40.8436 47.8299 40.4902L58.6944 33.9878C59.2482 33.658 59.5899 33.0572 59.5899 32.3975V19.2748C59.5899 18.6269 59.2482 18.0262 58.6944 17.6846L47.8299 11.1822C47.2408 10.8288 46.5102 10.8288 45.9328 11.1822L35.0684 17.6846C34.5146 18.0379 34.1729 18.6387 34.1729 19.2748Z",
    fill: "url(#paint166_radial_578_447492)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6016 18.4032V31.573C59.6016 32.0325 59.3541 32.4683 58.9535 32.6921L47.5471 39.277C47.1464 39.5126 46.6515 39.5126 46.2391 39.277L34.8327 32.6921C34.432 32.4565 34.1846 32.0325 34.1846 31.573V18.4032C34.1846 17.9438 34.432 17.508 34.8327 17.2842L46.2391 10.6993C46.6397 10.4637 47.1346 10.4637 47.5471 10.6993L58.9535 17.2842C59.3423 17.508 59.6016 17.932 59.6016 18.4032Z",
    fill: "url(#paint167_radial_578_447492)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9418 17.2724L47.5353 10.6876C47.1347 10.452 46.6398 10.452 46.2274 10.6876L34.8209 17.2724C34.4203 17.508 34.1729 17.9321 34.1729 18.4033V18.9216C34.1729 18.4622 34.4203 18.0264 34.8209 17.7908L46.2274 11.2059C46.628 10.9703 47.1229 10.9703 47.5353 11.2059L58.9418 17.7908C59.3425 18.0264 59.5899 18.4504 59.5899 18.9216V18.4033C59.6017 17.9321 59.3425 17.508 58.9418 17.2724Z",
    fill: "url(#paint168_radial_578_447492)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9418 32.6216L47.5353 39.2065C47.1347 39.4421 46.6398 39.4421 46.2274 39.2065L34.8209 32.6216C34.4203 32.386 34.1729 31.9619 34.1729 31.4907V31.5732C34.1729 32.0326 34.4203 32.4684 34.8209 32.704L46.2274 39.289C46.628 39.5245 47.1229 39.5245 47.5353 39.289L58.9418 32.704C59.3425 32.4684 59.5899 32.0444 59.5899 31.5732V31.4907C59.6017 31.9501 59.3425 32.386 58.9418 32.6216Z",
    fill: "url(#paint169_radial_578_447492)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6017 20.2058H34.1729V25.6951H59.6017V20.2058Z",
    fill: "url(#paint170_radial_578_447492)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6017 25.6829H34.1729V31.1722H59.6017V25.6829Z",
    fill: "url(#paint171_radial_578_447492)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9416 17.2724L47.5351 10.6876C47.1345 10.452 46.6396 10.452 46.2271 10.6876L34.8207 17.2724C34.7971 17.2842 34.7736 17.296 34.75 17.3196L45.7087 10.9938C46.1093 10.7583 46.6042 10.7583 47.0167 10.9938L58.4231 17.5787C58.8237 17.8143 59.0712 18.2384 59.0712 18.6978V31.8676C59.0712 32.3035 58.8591 32.7157 58.482 32.9513L58.9298 32.6922C59.3304 32.4566 59.5779 32.0325 59.5779 31.5731V18.4033C59.6015 17.9321 59.3422 17.508 58.9416 17.2724Z",
    fill: "url(#paint172_radial_578_447492)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9419 32.6446L47.5354 39.2295C47.1348 39.4651 46.6399 39.4651 46.2274 39.2295L34.821 32.6446C34.5618 32.4914 34.3615 32.2559 34.2554 31.985V19.2274C34.2554 18.7445 34.4439 18.3087 34.7503 17.967C34.385 18.3204 34.1611 18.8034 34.1611 19.3217V31.5255V31.608V32.4326C34.1611 33.0805 34.5029 33.6812 35.0567 34.0228L45.9211 40.5253C46.5103 40.8787 47.2408 40.8787 47.8182 40.5253L58.6826 34.0228C58.8358 33.9404 58.9654 33.8226 59.0833 33.7048C58.989 33.7872 58.883 33.8697 58.7651 33.9404L47.9007 40.4428C47.3115 40.7962 46.581 40.7962 46.0036 40.4428L35.1392 33.9404C34.5854 33.6105 34.2436 33.0098 34.2436 32.3501V32.0674C34.3497 32.3501 34.55 32.5857 34.8092 32.7271L46.2157 39.3119C46.6163 39.5475 47.1112 39.5475 47.5236 39.3119L58.9301 32.7271C59.3307 32.4915 59.5782 32.0674 59.5782 31.5962V31.5138C59.6018 31.985 59.3425 32.409 58.9419 32.6446Z",
    fill: "url(#paint173_radial_578_447492)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7539 20.4641V30.9952C36.7539 31.3486 36.9425 31.6785 37.2488 31.8434L46.3693 37.109C46.6756 37.2857 47.0527 37.2857 47.3591 37.109L56.4795 31.8434C56.7859 31.6667 56.9744 31.3368 56.9744 30.9952V20.4641C56.9744 20.1107 56.7859 19.7809 56.4795 19.616L47.3591 14.3504C47.0527 14.1737 46.6756 14.1737 46.3693 14.3504L37.2488 19.616C36.9425 19.7809 36.7539 20.1107 36.7539 20.4641Z",
    fill: "url(#paint174_linear_578_447492)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2842 20.7351V30.7126C37.2842 31.0424 37.4609 31.3604 37.7555 31.5254L46.3929 36.5082C46.6757 36.6732 47.041 36.6732 47.3238 36.5082L55.9611 31.5254C56.2439 31.3604 56.4324 31.0424 56.4324 30.7126V20.7351C56.4324 20.4053 56.2556 20.0872 55.9611 19.9223L47.3238 14.9395C47.041 14.7746 46.6757 14.7746 46.3929 14.9395L37.7555 19.9223C37.4609 20.099 37.2842 20.4053 37.2842 20.7351Z",
    fill: "url(#paint175_radial_578_447492)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2842 20.7351V30.7126C37.2842 31.0424 37.4609 31.3604 37.7555 31.5254L46.3929 36.5082C46.6757 36.6732 47.041 36.6732 47.3238 36.5082L55.9611 31.5254C56.2439 31.3604 56.4324 31.0424 56.4324 30.7126V20.7351C56.4324 20.4053 56.2556 20.0872 55.9611 19.9223L47.3238 14.9395C47.041 14.7746 46.6757 14.7746 46.3929 14.9395L37.7555 19.9223C37.4609 20.099 37.2842 20.4053 37.2842 20.7351Z",
    fill: "url(#paint176_radial_578_447492)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7891 20.4404C36.7891 20.087 36.9776 19.7571 37.2839 19.5922L46.4044 14.3266C46.7107 14.1499 47.0879 14.1499 47.3942 14.3266L56.5147 19.5922C56.821 19.7689 57.0095 20.0988 57.0095 20.4404V20.3108C57.0095 19.9574 56.821 19.6275 56.5147 19.4626L47.3942 14.1971C47.0879 14.0204 46.7107 14.0204 46.4044 14.1971L37.2839 19.4626C36.9776 19.6393 36.7891 19.9692 36.7891 20.3108V30.8419V20.4404Z",
    fill: "url(#paint177_radial_578_447492)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4795 31.6786L47.3591 36.9441C47.0527 37.1208 46.6756 37.1208 46.3693 36.9441L37.2488 31.6786C36.9425 31.5019 36.7539 31.1721 36.7539 30.8304V30.9836C36.7539 31.337 36.9425 31.6668 37.2488 31.8317L46.3693 37.0973C46.6756 37.274 47.0527 37.274 47.3591 37.0973L56.4795 31.8317C56.7859 31.655 56.9744 31.3252 56.9744 30.9836V30.8304C56.9744 31.1838 56.7859 31.5137 56.4795 31.6786Z",
    fill: "url(#paint178_radial_578_447492)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9728 19.9343L47.3355 14.9514C47.0527 14.7865 46.6873 14.7865 46.4045 14.9514L37.7672 19.9343C37.4844 20.0992 37.2959 20.4172 37.2959 20.7471V30.7245C37.2959 31.0544 37.4727 31.3724 37.7672 31.5373L46.4045 36.5202C46.6873 36.6851 47.0527 36.6851 47.3355 36.5202L55.9728 31.5373C56.2556 31.3724 56.4441 31.0544 56.4441 30.7245V20.7471C56.4441 20.4054 56.2674 20.0992 55.9728 19.9343ZM55.9964 30.4772C55.9964 30.7952 55.8314 31.0897 55.5486 31.2546L47.3119 36.0137C47.0291 36.1668 46.6991 36.1668 46.4281 36.0137L38.1915 31.2546C37.9087 31.1015 37.7436 30.807 37.7436 30.4772V20.9709C37.7436 20.6529 37.9087 20.3584 38.1915 20.1934L46.4281 15.4344C46.7109 15.2813 47.0409 15.2813 47.3119 15.4344L55.5486 20.1934C55.8314 20.3466 55.9964 20.6411 55.9964 20.9709V30.4772Z",
    fill: "url(#paint179_linear_578_447492)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8835 31.0897V20.5586C36.8835 20.2052 37.0721 19.8753 37.3785 19.7104L46.4989 14.4448C46.8053 14.2681 47.1823 14.2681 47.4887 14.4448L56.6091 19.7104C56.6327 19.7222 56.6681 19.7457 56.6916 19.7575C56.6327 19.6986 56.562 19.6397 56.4795 19.6044L47.3591 14.3388C47.0527 14.1621 46.6756 14.1621 46.3693 14.3388L37.2488 19.6044C36.9425 19.7811 36.7539 20.1109 36.7539 20.4525V30.9837C36.7539 31.3017 36.9071 31.5962 37.1663 31.7847C36.9778 31.608 36.8835 31.3488 36.8835 31.0897Z",
    fill: "url(#paint180_radial_578_447492)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9822 32.9274C50.978 32.9274 54.2173 29.6891 54.2173 25.6946C54.2173 21.7 50.978 18.4618 46.9822 18.4618C42.9864 18.4618 39.7471 21.7 39.7471 25.6946C39.7471 29.6891 42.9864 32.9274 46.9822 32.9274Z",
    fill: "url(#paint181_radial_578_447492)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2302 32.7152C51.226 32.7152 54.4653 29.477 54.4653 25.4824C54.4653 21.4878 51.226 18.2496 47.2302 18.2496C43.2344 18.2496 39.9951 21.4878 39.9951 25.4824C39.9951 29.477 43.2344 32.7152 47.2302 32.7152Z",
    fill: "url(#paint182_radial_578_447492)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1355 32.786C51.1313 32.786 54.3705 29.5478 54.3705 25.5532C54.3705 21.5586 51.1313 18.3204 47.1355 18.3204C43.1396 18.3204 39.9004 21.5586 39.9004 25.5532C39.9004 29.5478 43.1396 32.786 47.1355 32.786Z",
    fill: "url(#paint183_linear_578_447492)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1356 32.6331C51.0468 32.6331 54.2175 29.4634 54.2175 25.5534C54.2175 21.6434 51.0468 18.4738 47.1356 18.4738C43.2244 18.4738 40.0537 21.6434 40.0537 25.5534C40.0537 29.4634 43.2244 32.6331 47.1356 32.6331Z",
    fill: "url(#paint184_radial_578_447492)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M47.135 31.8085C50.5907 31.8085 53.392 29.008 53.392 25.5534C53.392 22.0988 50.5907 19.2983 47.135 19.2983C43.6793 19.2983 40.8779 22.0988 40.8779 25.5534C40.8779 29.008 43.6793 31.8085 47.135 31.8085Z",
    fill: "url(#paint185_radial_578_447492)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0648 19.4513C50.5174 19.4513 53.3218 22.2549 53.3218 25.7064C53.3218 26.6605 53.1097 27.5794 52.7209 28.3922C53.1569 27.544 53.4044 26.5781 53.4044 25.5414C53.4044 22.09 50.5999 19.2864 47.1473 19.2864C44.6492 19.2864 42.4928 20.7471 41.4912 22.8674C42.5164 20.8413 44.6256 19.4513 47.0648 19.4513Z",
    fill: "url(#paint186_radial_578_447492)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2057 31.7258C43.7531 31.7258 40.9486 28.9222 40.9486 25.4707C40.9486 23.9747 41.4789 22.5847 42.3627 21.5127C41.4436 22.5964 40.8779 24.01 40.8779 25.5532C40.8779 29.0047 43.6824 31.8083 47.135 31.8083C49.0911 31.8083 50.8468 30.913 51.9898 29.4994C50.835 30.8659 49.1264 31.7258 47.2057 31.7258Z",
    fill: "url(#paint187_radial_578_447492)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M47.135 24.0925C49.5035 24.0925 51.6834 24.5755 53.392 25.3883C53.3096 21.9958 50.5404 19.2864 47.135 19.2864C43.7296 19.2864 40.9604 22.0075 40.8779 25.3883C42.5865 24.5755 44.7665 24.0925 47.135 24.0925Z",
    fill: "url(#paint188_radial_578_447492)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6954 30.4459V38.7507C62.6954 40.6001 61.8352 42.2846 60.4447 43.1681L49.6863 50.0121C48.779 50.5893 47.7774 50.872 46.764 50.872C45.7742 50.872 44.7844 50.5893 43.8889 50.0121L33.1305 43.1681C31.74 42.2846 30.8799 40.5883 30.8799 38.7507V30.4459H34.0968V32.5545C34.0968 33.3084 34.4385 34.0151 34.9923 34.4039L45.8567 42.0018C46.4459 42.4141 47.1765 45.1235 47.7538 44.7112L58.6183 34.3921C59.1721 34.0034 59.5138 33.2966 59.5138 32.5427V30.4459H62.6954Z",
    fill: "url(#paint189_radial_578_447492)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6955 34.8867V38.7505C62.6955 40.5999 61.8353 42.2844 60.4448 43.1679L49.6864 50.0119C48.7791 50.5891 47.7775 50.8719 46.7641 50.8719V48.0683L45.7979 44.393L62.6955 34.8867Z",
    fill: "url(#paint190_radial_578_447492)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6954 30.3871V37.879C62.6954 39.4575 61.8352 40.9064 60.4447 41.6603L56.4854 43.816L49.6863 47.5148C47.8834 48.5043 45.7035 48.5043 43.9007 47.5148L41.5675 46.2426L37.0426 43.7806L33.1423 41.6603C31.7518 40.9064 30.8916 39.4575 30.8916 37.879V30.3871H34.1085V32.1894C34.1085 32.8373 34.4503 33.438 35.0041 33.7796L41.049 37.396L45.8685 40.2821C46.4576 40.6355 47.1882 40.6355 47.7656 40.2821L53.2568 36.9955L58.6418 33.7796C59.1956 33.4498 59.5373 32.8373 59.5373 32.1894V30.3871H62.6954Z",
    fill: "url(#paint191_radial_578_447492)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6954 30.3873V37.8792C62.6954 39.4577 61.8352 40.9066 60.4447 41.6605L57.652 43.1919L53.2686 36.984L58.6536 33.768C59.2074 33.4382 59.5491 32.8257 59.5491 32.1778V30.3755L62.6954 30.3873Z",
    fill: "url(#paint192_radial_578_447492)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M41.049 37.396L36.2296 43.3801L33.1305 41.6603C31.74 40.9064 30.8799 39.4575 30.8799 37.879V30.3871H34.0968V32.1894C34.0968 32.8373 34.4385 33.438 34.9923 33.7796L41.049 37.396Z",
    fill: "url(#paint193_radial_578_447492)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4447 41.248L49.6863 47.1026C47.8834 48.0921 45.7035 48.0921 43.9007 47.1026L33.1423 41.248C31.7518 40.4941 30.8916 39.0452 30.8916 37.4667V37.879C30.8916 39.4575 31.7518 40.9064 33.1423 41.6603L43.9007 47.5149C45.7035 48.5044 47.8834 48.5044 49.6863 47.5149L60.4447 41.6603C61.8352 40.9064 62.6954 39.4575 62.6954 37.879V37.4667C62.6954 39.0452 61.8234 40.5059 60.4447 41.248Z",
    fill: "url(#paint194_radial_578_447492)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6954 30.3871V37.879C62.6954 39.4575 61.8352 40.9064 60.4447 41.6603L56.4854 43.816L49.6863 47.5148C47.8834 48.5043 45.7035 48.5043 43.9007 47.5148L41.5675 46.2426L37.0426 43.7806L33.1423 41.6603C31.7518 40.9064 30.8916 39.4575 30.8916 37.879V30.3871H34.1085V32.1894C34.1085 32.8373 34.4503 33.438 35.0041 33.7796L41.049 37.396L45.8685 40.2821C46.4576 40.6355 47.1882 40.6355 47.7656 40.2821L53.2568 36.9955L58.6418 33.7796C59.1956 33.4498 59.5373 32.8373 59.5373 32.1894V30.3871H62.6954Z",
    fill: "url(#paint195_linear_578_447492)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9143 39.4574C37.9636 39.529 37.9635 39.6235 37.914 39.6951C37.7397 39.947 37.5473 40.1889 37.3407 40.4167C37.3281 40.4293 37.3155 40.4481 37.2967 40.4607C37.2275 40.5359 37.1521 40.6112 37.0767 40.6864C36.9007 40.8621 36.7247 41.0251 36.5299 41.1756C36.3841 41.2961 36.2342 41.4084 36.0772 41.516C36.0053 41.5652 35.9107 41.5649 35.8403 41.5138C35.5385 41.2946 35.1163 40.9303 34.7568 40.5661C34.4638 40.2693 34.1653 39.8868 34.0194 39.6935C33.9638 39.6199 33.9628 39.5194 34.0162 39.4442C34.0934 39.3352 34.2045 39.1809 34.2797 39.0871C34.4557 38.8676 34.6443 38.6544 34.8391 38.4537C34.946 38.347 35.0528 38.2467 35.1659 38.1463C35.3807 37.9589 35.6045 37.7851 35.8376 37.6212C35.9099 37.5703 36.0062 37.5698 36.0791 37.6199C36.2437 37.733 36.4034 37.8509 36.555 37.977C36.7373 38.1275 36.907 38.2843 37.0704 38.4474C37.3874 38.7693 37.6686 39.1014 37.9143 39.4574Z",
    fill: "#FED3B6"
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4731 39.5741C37.3279 39.7938 37.1641 40.0041 36.9862 40.2004C36.9769 40.2097 36.9675 40.2238 36.9534 40.2331C36.902 40.2892 36.8458 40.3453 36.7896 40.4014C36.6585 40.5322 36.5275 40.6537 36.3823 40.7659C36.2466 40.8781 36.1062 40.9809 35.9564 41.079C35.7317 40.9295 35.521 40.7659 35.3197 40.5883C34.9967 40.2985 34.7112 39.9714 34.4677 39.6068C34.4584 39.5928 34.449 39.5835 34.4443 39.5694C34.5286 39.4479 34.6129 39.3264 34.7065 39.2096C34.8376 39.046 34.978 38.8871 35.1231 38.7375C35.2027 38.6581 35.2823 38.5833 35.3665 38.5085C35.5538 38.3449 35.7504 38.1954 35.9564 38.0552C36.1108 38.158 36.2606 38.2655 36.4011 38.3823C36.5368 38.4945 36.6632 38.6113 36.7849 38.7329C37.0471 38.9993 37.2764 39.275 37.4731 39.5741Z",
    fill: "url(#paint196_radial_578_447492)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4739 39.5744H35.9619V38.0695C36.2615 38.2658 36.5424 38.4948 36.7952 38.7471C37.0479 38.9995 37.2773 39.2753 37.4739 39.5744Z",
    fill: "url(#paint197_radial_578_447492)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9612 38.0695V39.5791H34.4492C34.6458 39.2799 34.8752 38.9995 35.128 38.7471C35.3855 38.4948 35.6616 38.2658 35.9612 38.0695Z",
    fill: "url(#paint198_radial_578_447492)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9612 39.5745V41.0841C35.362 40.6868 34.8471 40.1727 34.4492 39.5745H35.9612Z",
    fill: "url(#paint199_radial_578_447492)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4739 39.5745C37.2773 39.8736 37.0479 40.154 36.7952 40.4064C36.5424 40.6588 36.2615 40.8878 35.9619 41.0841V39.5745H37.4739Z",
    fill: "url(#paint200_radial_578_447492)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4727 39.5741C37.2761 39.8732 37.0467 40.1537 36.7939 40.406C36.5411 40.6584 36.2602 40.8874 35.9606 41.0837C35.7359 40.9342 35.6564 40.8828 35.4551 40.7052L36.4054 38.3964C36.5411 38.5085 36.6675 38.6254 36.7892 38.7469C37.0467 38.9993 37.2761 39.275 37.4727 39.5741Z",
    fill: "url(#paint201_radial_578_447492)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9584 40.2375C36.9069 40.2936 36.8507 40.3496 36.7945 40.4057C36.5417 40.6581 36.2609 40.8871 35.9613 41.0834C35.7366 40.9339 35.5259 40.7703 35.3246 40.5927C35.0016 40.3029 34.7161 39.9758 34.4727 39.6112C35.1046 39.7982 36.0315 40.0552 36.9584 40.2375Z",
    fill: "url(#paint202_radial_578_447492)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9872 40.2005C36.9778 40.2099 36.9685 40.2239 36.9544 40.2332C36.9029 40.2893 36.8468 40.3454 36.7906 40.4015C36.6595 40.5323 36.5284 40.6539 36.3833 40.766C36.0276 40.1351 35.6343 39.3779 35.6016 39.0835C35.6062 39.0882 36.3927 39.7378 36.9872 40.2005Z",
    fill: "url(#paint203_radial_578_447492)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9618 39.5744L34.7119 39.2145C34.843 39.0509 34.9834 38.892 35.1285 38.7424C35.2081 38.663 35.2877 38.5882 35.372 38.5134L35.9618 39.5744Z",
    fill: "url(#paint204_radial_578_447492)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9619 40.5701C35.5687 40.3084 35.227 39.9719 34.9648 39.5746C35.227 39.182 35.564 38.8408 35.9619 38.5791C36.3552 38.8408 36.6969 39.1773 36.959 39.5746C36.6969 39.9719 36.3598 40.3084 35.9619 40.5701Z",
    fill: "url(#paint205_radial_578_447492)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7114 39.2844C34.8424 39.1208 34.9829 38.9619 35.128 38.8123C35.2076 38.7329 35.2871 38.6581 35.3714 38.5833C35.5587 38.4197 35.7553 38.2702 35.9612 38.13C36.1157 38.2328 36.2655 38.3403 36.406 38.4571C36.5417 38.5693 36.6681 38.6861 36.7898 38.8076C37.0332 39.0507 37.2532 39.3171 37.4452 39.6022C37.4545 39.5881 37.4592 39.5788 37.4686 39.5648C37.272 39.2657 37.0426 38.9852 36.7898 38.7329C36.6681 38.6113 36.537 38.4945 36.406 38.3823C36.2655 38.2655 36.1157 38.1533 35.9612 38.0552C35.7553 38.1907 35.5587 38.3449 35.3714 38.5085C35.2871 38.5833 35.2076 38.6581 35.128 38.7375C34.9782 38.8871 34.8378 39.0413 34.7114 39.2096C34.6177 39.3264 34.5335 39.4479 34.4492 39.5694C34.4586 39.5835 34.4633 39.5928 34.4726 39.6068C34.5522 39.4993 34.6318 39.3918 34.7114 39.2844Z",
    fill: "url(#paint206_radial_578_447492)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9862 40.1304C36.9769 40.1398 36.9675 40.1538 36.9534 40.1631C36.902 40.2192 36.8458 40.2753 36.7896 40.3314C36.6585 40.4623 36.5275 40.5838 36.3823 40.6959C36.2466 40.8081 36.1062 40.9109 35.9564 41.0091C35.7317 40.8595 35.521 40.6959 35.3197 40.5183C34.9967 40.2286 34.7112 39.9014 34.4677 39.5369C34.4584 39.5509 34.449 39.5602 34.4443 39.5743C34.4537 39.5883 34.4631 39.5976 34.4677 39.6116C34.7112 39.9715 34.9967 40.2987 35.3197 40.5931C35.5163 40.7707 35.7317 40.939 35.9564 41.0839C36.1015 40.9857 36.2466 40.8829 36.3823 40.7707C36.5228 40.6539 36.6585 40.5324 36.7896 40.4062C36.8458 40.3501 36.8973 40.294 36.9534 40.2379C36.9628 40.2286 36.9722 40.2146 36.9862 40.2052C37.1641 40.0089 37.3233 39.7986 37.4731 39.5789C37.4637 39.5649 37.4543 39.5556 37.4497 39.5415C37.3092 39.7472 37.1547 39.9435 36.9862 40.1304Z",
    fill: "url(#paint207_radial_578_447492)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.128 38.8123C34.9829 38.9619 34.8424 39.1208 34.7113 39.2844L34.4947 39.5769C34.7322 39.9254 35.0086 40.2392 35.3197 40.5184C35.521 40.696 35.7317 40.8595 35.9564 41.0091C36.1062 40.911 36.2466 40.8081 36.3823 40.696C36.5275 40.5838 36.6585 40.4623 36.7896 40.3314C36.8458 40.2753 36.902 40.2193 36.9534 40.1632C36.963 40.1568 36.9705 40.1482 36.9772 40.1404C36.9803 40.1368 36.9833 40.1334 36.9862 40.1305C37.1456 39.9536 37.2924 39.7685 37.4267 39.5749C37.2392 39.3001 37.0254 39.0429 36.7898 38.8076C36.6681 38.6861 36.5417 38.5693 36.4059 38.4571C36.2655 38.3403 36.1157 38.2328 35.9612 38.13C35.7553 38.2702 35.5586 38.4197 35.3714 38.5833C35.2871 38.6581 35.2076 38.7329 35.128 38.8123ZM37.4659 39.5689C37.4667 39.5675 37.4676 39.5662 37.4686 39.5648C37.272 39.2657 37.0426 38.9852 36.7898 38.7329C36.6681 38.6113 36.537 38.4945 36.4059 38.3823C36.2655 38.2655 36.1157 38.1533 35.9612 38.0552C35.7553 38.1907 35.5586 38.3449 35.3714 38.5085C35.2871 38.5833 35.2076 38.6581 35.128 38.7375C34.9782 38.8871 34.8377 39.0413 34.7113 39.2096C34.6253 39.3169 34.5472 39.4282 34.4697 39.5399C34.4691 39.5389 34.4684 39.5379 34.4677 39.5369C34.4649 39.5411 34.4622 39.5448 34.4595 39.5484C34.4532 39.5569 34.4476 39.5644 34.4443 39.5743C34.4471 39.5785 34.4499 39.5822 34.4526 39.5858C34.4589 39.5943 34.4645 39.6018 34.4677 39.6117C34.7112 39.9715 34.9967 40.2987 35.3197 40.5931C35.5163 40.7707 35.7317 40.939 35.9564 41.0839C36.1015 40.9857 36.2466 40.8829 36.3823 40.7707C36.5228 40.6539 36.6585 40.5324 36.7896 40.4062C36.8177 40.3782 36.8446 40.3501 36.8715 40.3221C36.8984 40.294 36.9254 40.266 36.9534 40.2379C36.9564 40.235 36.9594 40.2316 36.9625 40.228C36.9692 40.2202 36.9766 40.2116 36.9862 40.2052C37.1641 40.0089 37.3233 39.7986 37.4731 39.579C37.4706 39.5753 37.4682 39.572 37.4659 39.5689Z",
    fill: "url(#paint208_radial_578_447492)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9619 38.5829C35.9619 38.5829 36.5517 38.9521 36.959 39.5784C36.959 39.5737 36.6688 38.9287 35.9619 38.5829Z",
    fill: "url(#paint209_radial_578_447492)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9688 39.5747C34.9688 39.5747 35.3198 40.1916 35.9143 40.5609L35.9612 41.0095L35.9939 40.5515C35.9939 40.5515 36.4386 40.3646 36.9583 39.5747C36.9583 39.5747 36.3029 40.4534 35.9518 40.5001C35.9518 40.5048 35.5445 40.3459 34.9688 39.5747Z",
    fill: "url(#paint210_radial_578_447492)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9658 40.5654C35.9658 40.5654 36.5837 40.2149 36.9535 39.6213L37.4029 39.5746L36.9442 39.5419C36.9442 39.5419 36.7569 39.0979 35.9658 38.5791C35.9658 38.5791 36.8459 39.2334 36.8927 39.5839C36.8974 39.5839 36.7382 39.9906 35.9658 40.5654Z",
    fill: "url(#paint211_radial_578_447492)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M35.943 38.5791C35.943 38.5791 35.3251 38.9296 34.9553 39.5232L34.5059 39.5699L34.9646 39.6026C34.9646 39.6026 35.1519 40.0466 35.943 40.5654C35.943 40.5654 35.0629 39.9111 35.0161 39.5606C35.0114 39.5606 35.1706 39.154 35.943 38.5791Z",
    fill: "url(#paint212_radial_578_447492)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9583 39.5692C36.9583 39.5692 36.6072 38.9523 36.0127 38.5831L35.9658 38.1344L35.9331 38.5924C35.9331 38.5924 35.4884 38.7794 34.9688 39.5692C34.9688 39.5692 35.6241 38.6906 35.9752 38.6438C35.9752 38.6392 36.3825 38.7981 36.9583 39.5692Z",
    fill: "url(#paint213_radial_578_447492)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3508 41.9323C43.4002 42.0039 43.4 42.0984 43.3506 42.1699C43.1763 42.4219 42.9838 42.6638 42.7772 42.8916C42.7646 42.9041 42.7521 42.923 42.7332 42.9355C42.6641 43.0108 42.5886 43.086 42.5132 43.1613C42.3372 43.3369 42.1612 43.5 41.9664 43.6505C41.8206 43.7709 41.6708 43.8833 41.5137 43.9909C41.4419 44.04 41.3472 44.0398 41.2768 43.9886C40.975 43.7694 40.5528 43.4052 40.1933 43.041C39.9003 42.7441 39.6018 42.3617 39.4559 42.1684C39.4004 42.0948 39.3994 41.9943 39.4527 41.919C39.5299 41.8101 39.6411 41.6557 39.7162 41.562C39.8922 41.3425 40.0808 41.1292 40.2756 40.9285C40.3825 40.8219 40.4893 40.7215 40.6025 40.6212C40.8172 40.4337 41.0411 40.26 41.2741 40.096C41.3465 40.0452 41.4427 40.0446 41.5156 40.0947C41.6802 40.2078 41.8399 40.3258 41.9915 40.4518C42.1738 40.6024 42.3435 40.7592 42.5069 40.9222C42.8239 41.2442 43.1052 41.5763 43.3508 41.9323Z",
    fill: "#FFD1B2"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3508 41.9323C43.4002 42.0039 43.4 42.0984 43.3506 42.1699C43.1763 42.4219 42.9838 42.6638 42.7772 42.8916C42.7646 42.9041 42.7521 42.923 42.7332 42.9355C42.6641 43.0108 42.5886 43.086 42.5132 43.1613C42.3372 43.3369 42.1612 43.5 41.9664 43.6505C41.8206 43.7709 41.6708 43.8833 41.5137 43.9909C41.4419 44.04 41.3472 44.0398 41.2768 43.9886C40.975 43.7694 40.5528 43.4052 40.1933 43.041C39.9003 42.7441 39.6018 42.3617 39.4559 42.1684C39.4004 42.0948 39.3994 41.9943 39.4527 41.919C39.5299 41.8101 39.6411 41.6557 39.7162 41.562C39.8922 41.3425 40.0808 41.1292 40.2756 40.9285C40.3825 40.8219 40.4893 40.7215 40.6025 40.6212C40.8172 40.4337 41.0411 40.26 41.2741 40.096C41.3465 40.0452 41.4427 40.0446 41.5156 40.0947C41.6802 40.2078 41.8399 40.3258 41.9915 40.4518C42.1738 40.6024 42.3435 40.7592 42.5069 40.9222C42.8239 41.2442 43.1052 41.5763 43.3508 41.9323Z",
    fill: "#FED3B6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9096 42.049C42.7645 42.2686 42.6006 42.479 42.4227 42.6753C42.4134 42.6846 42.404 42.6986 42.39 42.708C42.3385 42.764 42.2823 42.8201 42.2261 42.8762C42.0951 43.0071 41.964 43.1286 41.8189 43.2408C41.6831 43.3529 41.5427 43.4558 41.3929 43.5539C41.1682 43.4043 40.9575 43.2408 40.7562 43.0632C40.4332 42.7734 40.1477 42.4462 39.9043 42.0817C39.8949 42.0677 39.8855 42.0583 39.8809 42.0443C39.9651 41.9228 40.0494 41.8013 40.143 41.6844C40.2741 41.5208 40.4145 41.3619 40.5596 41.2124C40.6392 41.1329 40.7188 41.0582 40.8031 40.9834C40.9903 40.8198 41.1869 40.6702 41.3929 40.53C41.5474 40.6329 41.6972 40.7403 41.8376 40.8572C41.9733 40.9694 42.0997 41.0862 42.2214 41.2077C42.4836 41.4741 42.713 41.7499 42.9096 42.049Z",
    fill: "url(#paint214_radial_578_447492)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9105 42.0492H41.3984V40.5443C41.698 40.7406 41.9789 40.9696 42.2317 41.222C42.4845 41.4744 42.7138 41.7501 42.9105 42.0492Z",
    fill: "url(#paint215_radial_578_447492)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3978 40.5443V42.0539H39.8857C40.0824 41.7548 40.3117 41.4744 40.5645 41.222C40.822 40.9696 41.0982 40.7406 41.3978 40.5443Z",
    fill: "url(#paint216_radial_578_447492)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3978 42.0493V43.5589C40.7986 43.1617 40.2836 42.6475 39.8857 42.0493H41.3978Z",
    fill: "url(#paint217_radial_578_447492)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9105 42.0493C42.7138 42.3484 42.4845 42.6289 42.2317 42.8812C41.9789 43.1336 41.698 43.3626 41.3984 43.5589V42.0493H42.9105Z",
    fill: "url(#paint218_radial_578_447492)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9092 42.049C42.7126 42.3481 42.4832 42.6285 42.2304 42.8809C41.9776 43.1333 41.6968 43.3623 41.3972 43.5586C41.1725 43.409 41.0929 43.3576 40.8916 43.18L41.8419 40.8712C41.9776 40.9834 42.104 41.1002 42.2257 41.2217C42.4832 41.4741 42.7126 41.7499 42.9092 42.049Z",
    fill: "url(#paint219_radial_578_447492)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3949 42.7123C42.3434 42.7684 42.2872 42.8245 42.231 42.8806C41.9783 43.133 41.6974 43.362 41.3978 43.5583C41.1731 43.4087 40.9624 43.2451 40.7612 43.0675C40.4382 42.7778 40.1526 42.4506 39.9092 42.0861C40.5411 42.273 41.468 42.5301 42.3949 42.7123Z",
    fill: "url(#paint220_radial_578_447492)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4237 42.6754C42.4144 42.6847 42.405 42.6987 42.3909 42.7081C42.3395 42.7642 42.2833 42.8202 42.2271 42.8763C42.096 43.0072 41.965 43.1287 41.8198 43.2409C41.4641 42.6099 41.0709 41.8528 41.0381 41.5583C41.0428 41.563 41.8292 42.2127 42.4237 42.6754Z",
    fill: "url(#paint221_radial_578_447492)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3983 42.0492L40.1484 41.6893C40.2795 41.5258 40.4199 41.3668 40.5651 41.2173C40.6446 41.1378 40.7242 41.0631 40.8085 40.9883L41.3983 42.0492Z",
    fill: "url(#paint222_radial_578_447492)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3985 43.0449C41.0052 42.7832 40.6635 42.4467 40.4014 42.0495C40.6635 41.6569 41.0006 41.3157 41.3985 41.054C41.7917 41.3157 42.1334 41.6522 42.3955 42.0495C42.1334 42.4467 41.7964 42.7832 41.3985 43.0449Z",
    fill: "url(#paint223_radial_578_447492)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1479 41.7592C40.279 41.5956 40.4194 41.4367 40.5645 41.2872C40.6441 41.2077 40.7237 41.1329 40.8079 41.0582C40.9952 40.8946 41.1918 40.745 41.3978 40.6048C41.5522 40.7076 41.702 40.8151 41.8425 40.932C41.9782 41.0441 42.1046 41.161 42.2263 41.2825C42.4698 41.5255 42.6898 41.7919 42.8817 42.077C42.8911 42.063 42.8957 42.0536 42.9051 42.0396C42.7085 41.7405 42.4791 41.4601 42.2263 41.2077C42.1046 41.0862 41.9735 40.9694 41.8425 40.8572C41.702 40.7403 41.5522 40.6282 41.3978 40.53C41.1918 40.6656 40.9952 40.8198 40.8079 40.9834C40.7237 41.0582 40.6441 41.1329 40.5645 41.2124C40.4147 41.3619 40.2743 41.5162 40.1479 41.6844C40.0543 41.8013 39.97 41.9228 39.8857 42.0443C39.8951 42.0583 39.8998 42.0677 39.9091 42.0817C39.9887 41.9742 40.0683 41.8667 40.1479 41.7592Z",
    fill: "url(#paint224_radial_578_447492)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4227 42.6053C42.4134 42.6146 42.404 42.6286 42.39 42.638C42.3385 42.6941 42.2823 42.7502 42.2261 42.8062C42.0951 42.9371 41.964 43.0586 41.8189 43.1708C41.6831 43.283 41.5427 43.3858 41.3929 43.4839C41.1682 43.3344 40.9575 43.1708 40.7562 42.9932C40.4332 42.7034 40.1477 42.3763 39.9043 42.0117C39.8949 42.0257 39.8855 42.0351 39.8809 42.0491C39.8902 42.0631 39.8996 42.0725 39.9043 42.0865C40.1477 42.4464 40.4332 42.7735 40.7562 43.068C40.9528 43.2456 41.1682 43.4138 41.3929 43.5587C41.538 43.4606 41.6831 43.3577 41.8189 43.2456C41.9593 43.1287 42.0951 43.0072 42.2261 42.881C42.2823 42.8249 42.3338 42.7689 42.39 42.7128C42.3993 42.7034 42.4087 42.6894 42.4227 42.6801C42.6006 42.4838 42.7598 42.2734 42.9096 42.0538C42.9002 42.0398 42.8909 42.0304 42.8862 42.0164C42.7457 42.222 42.5913 42.4183 42.4227 42.6053Z",
    fill: "url(#paint225_radial_578_447492)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5645 41.2872C40.4194 41.4367 40.2789 41.5956 40.1479 41.7592L39.9313 42.0518C40.1687 42.4003 40.4451 42.7141 40.7562 42.9932C40.9575 43.1708 41.1682 43.3344 41.3929 43.484C41.5427 43.3858 41.6831 43.283 41.8189 43.1708C41.964 43.0587 42.0951 42.9371 42.2261 42.8063C42.2823 42.7502 42.3385 42.6941 42.39 42.638C42.3996 42.6316 42.407 42.6231 42.4137 42.6153C42.4168 42.6117 42.4198 42.6083 42.4227 42.6053C42.5821 42.4285 42.729 42.2433 42.8632 42.0498C42.6757 41.7749 42.462 41.5178 42.2263 41.2825C42.1046 41.161 41.9782 41.0441 41.8425 40.932C41.702 40.8151 41.5522 40.7076 41.3977 40.6048C41.1918 40.745 40.9952 40.8946 40.8079 41.0582C40.7237 41.1329 40.6441 41.2077 40.5645 41.2872ZM42.9024 42.0437C42.9033 42.0424 42.9041 42.041 42.9051 42.0396C42.7085 41.7405 42.4791 41.4601 42.2263 41.2077C42.1046 41.0862 41.9735 40.9694 41.8425 40.8572C41.702 40.7403 41.5522 40.6282 41.3977 40.53C41.1918 40.6656 40.9952 40.8198 40.8079 40.9834C40.7237 41.0582 40.6441 41.1329 40.5645 41.2124C40.4147 41.3619 40.2743 41.5162 40.1479 41.6844C40.0618 41.7918 39.9837 41.9031 39.9062 42.0147C39.9056 42.0137 39.9049 42.0127 39.9043 42.0117C39.9015 42.0159 39.8987 42.0197 39.896 42.0233C39.8897 42.0318 39.8841 42.0393 39.8809 42.0491C39.8837 42.0533 39.8864 42.0571 39.8891 42.0607C39.8954 42.0692 39.901 42.0767 39.9043 42.0865C40.1477 42.4464 40.4332 42.7736 40.7562 43.068C40.9528 43.2456 41.1682 43.4139 41.3929 43.5587C41.538 43.4606 41.6831 43.3578 41.8189 43.2456C41.9593 43.1288 42.0951 43.0072 42.2261 42.8811C42.2542 42.853 42.2811 42.825 42.3081 42.7969C42.335 42.7689 42.3619 42.7408 42.39 42.7128C42.3929 42.7098 42.3959 42.7064 42.399 42.7028C42.4057 42.695 42.4131 42.6865 42.4227 42.6801C42.6006 42.4838 42.7598 42.2735 42.9096 42.0538C42.9072 42.0502 42.9047 42.0469 42.9024 42.0437Z",
    fill: "url(#paint226_radial_578_447492)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3984 41.0577C41.3984 41.0577 41.9883 41.427 42.3955 42.0532C42.3955 42.0486 42.1053 41.4036 41.3984 41.0577Z",
    fill: "url(#paint227_radial_578_447492)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4053 42.0496C40.4053 42.0496 40.7564 42.6665 41.3509 43.0357L41.3977 43.4844L41.4305 43.0264C41.4305 43.0264 41.8752 42.8394 42.3948 42.0496C42.3948 42.0496 41.7394 42.9282 41.3883 42.9749C41.3883 42.9796 40.9811 42.8207 40.4053 42.0496Z",
    fill: "url(#paint228_radial_578_447492)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4023 43.0403C41.4023 43.0403 42.0203 42.6897 42.3901 42.0962L42.8395 42.0495L42.3807 42.0167C42.3807 42.0167 42.1935 41.5727 41.4023 41.054C41.4023 41.054 42.2824 41.7083 42.3292 42.0588C42.3339 42.0588 42.1747 42.4654 41.4023 43.0403Z",
    fill: "url(#paint229_radial_578_447492)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3795 41.054C41.3795 41.054 40.7616 41.4045 40.3918 41.998L39.9424 42.0448L40.4011 42.0775C40.4011 42.0775 40.5884 42.5215 41.3795 43.0403C41.3795 43.0403 40.4994 42.386 40.4526 42.0354C40.448 42.0354 40.6071 41.6288 41.3795 41.054Z",
    fill: "url(#paint230_radial_578_447492)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3948 42.0441C42.3948 42.0441 42.0437 41.4271 41.4492 41.0579L41.4024 40.6093L41.3696 41.0673C41.3696 41.0673 40.9249 41.2542 40.4053 42.0441C40.4053 42.0441 41.0606 41.1654 41.4117 41.1187C41.4117 41.114 41.819 41.2729 42.3948 42.0441Z",
    fill: "url(#paint231_radial_578_447492)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7863 44.5484C48.8357 44.62 48.8356 44.7145 48.7861 44.786C48.6118 45.0379 48.4193 45.2799 48.2128 45.5077C48.2002 45.5202 48.1876 45.5391 48.1688 45.5516C48.0996 45.6269 48.0242 45.7021 47.9488 45.7774C47.7728 45.953 47.5968 46.1161 47.4019 46.2666C47.2561 46.387 47.1063 46.4994 46.9492 46.6069C46.8774 46.6561 46.7828 46.6559 46.7123 46.6047C46.4105 46.3855 45.9884 46.0213 45.6288 45.6571C45.3358 45.3602 45.0373 44.9777 44.8915 44.7845C44.8359 44.7109 44.8349 44.6103 44.8882 44.5351C44.9655 44.4262 45.0766 44.2718 45.1518 44.1781C45.3278 43.9585 45.5163 43.7453 45.7112 43.5446C45.818 43.438 45.9249 43.3376 46.038 43.2373C46.2527 43.0498 46.4766 42.8761 46.7097 42.7121C46.782 42.6612 46.8783 42.6607 46.9512 42.7108C47.1158 42.8239 47.2755 42.9419 47.4271 43.0679C47.6094 43.2185 47.7791 43.3753 47.9425 43.5383C48.2594 43.8603 48.5407 44.1923 48.7863 44.5484Z",
    fill: "#FFD1B2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7863 44.5484C48.8357 44.62 48.8356 44.7145 48.7861 44.786C48.6118 45.0379 48.4193 45.2799 48.2128 45.5077C48.2002 45.5202 48.1876 45.5391 48.1688 45.5516C48.0996 45.6269 48.0242 45.7021 47.9488 45.7774C47.7728 45.953 47.5968 46.1161 47.4019 46.2666C47.2561 46.387 47.1063 46.4994 46.9492 46.6069C46.8774 46.6561 46.7828 46.6559 46.7123 46.6047C46.4105 46.3855 45.9884 46.0213 45.6288 45.6571C45.3358 45.3602 45.0373 44.9777 44.8915 44.7845C44.8359 44.7109 44.8349 44.6103 44.8882 44.5351C44.9655 44.4262 45.0766 44.2718 45.1518 44.1781C45.3278 43.9585 45.5163 43.7453 45.7112 43.5446C45.818 43.438 45.9249 43.3376 46.038 43.2373C46.2527 43.0498 46.4766 42.8761 46.7097 42.7121C46.782 42.6612 46.8783 42.6607 46.9512 42.7108C47.1158 42.8239 47.2755 42.9419 47.4271 43.0679C47.6094 43.2185 47.7791 43.3753 47.9425 43.5383C48.2594 43.8603 48.5407 44.1923 48.7863 44.5484Z",
    fill: "#FED3B6"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3451 44.6651C48.2 44.8847 48.0362 45.095 47.8583 45.2913C47.8489 45.3007 47.8396 45.3147 47.8255 45.3241C47.774 45.3801 47.7179 45.4362 47.6617 45.4923C47.5306 45.6232 47.3995 45.7447 47.2544 45.8569C47.1187 45.969 46.9782 46.0718 46.8284 46.17C46.6037 46.0204 46.3931 45.8569 46.1918 45.6793C45.8688 45.3895 45.5832 45.0623 45.3398 44.6978C45.3304 44.6838 45.3211 44.6744 45.3164 44.6604C45.4007 44.5389 45.4849 44.4174 45.5786 44.3005C45.7096 44.1369 45.8501 43.978 45.9952 43.8285C46.0748 43.749 46.1543 43.6742 46.2386 43.5995C46.4258 43.4359 46.6225 43.2863 46.8284 43.1461C46.9829 43.2489 47.1327 43.3564 47.2731 43.4733C47.4089 43.5854 47.5353 43.7023 47.657 43.8238C47.9191 44.0902 48.1485 44.3659 48.3451 44.6651Z",
    fill: "url(#paint232_radial_578_447492)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M48.346 44.6653H46.834V43.1604C47.1336 43.3567 47.4145 43.5857 47.6672 43.8381C47.92 44.0905 48.1494 44.3662 48.346 44.6653Z",
    fill: "url(#paint233_radial_578_447492)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8333 43.1604V44.67H45.3213C45.5179 44.3709 45.7473 44.0905 46.0001 43.8381C46.2575 43.5857 46.5337 43.3567 46.8333 43.1604Z",
    fill: "url(#paint234_radial_578_447492)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8333 44.6654V46.175C46.2341 45.7777 45.7192 45.2636 45.3213 44.6654H46.8333Z",
    fill: "url(#paint235_radial_578_447492)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M48.346 44.6654C48.1494 44.9645 47.92 45.2449 47.6672 45.4973C47.4145 45.7497 47.1336 45.9787 46.834 46.175V44.6654H48.346Z",
    fill: "url(#paint236_radial_578_447492)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3447 44.6651C48.1481 44.9642 47.9187 45.2446 47.666 45.497C47.4132 45.7494 47.1323 45.9784 46.8327 46.1747C46.608 46.0251 46.5284 45.9737 46.3271 45.7961L47.2774 43.4873C47.4132 43.5995 47.5396 43.7163 47.6613 43.8378C47.9188 44.0902 48.1481 44.366 48.3447 44.6651Z",
    fill: "url(#paint237_radial_578_447492)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8304 45.3284C47.7789 45.3845 47.7228 45.4406 47.6666 45.4967C47.4138 45.7491 47.1329 45.9781 46.8333 46.1744C46.6086 46.0248 46.398 45.8612 46.1967 45.6836C45.8737 45.3939 45.5881 45.0667 45.3447 44.7021C45.9767 44.8891 46.9036 45.1461 47.8304 45.3284Z",
    fill: "url(#paint238_radial_578_447492)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8593 45.2914C47.8499 45.3008 47.8405 45.3148 47.8265 45.3242C47.775 45.3802 47.7188 45.4363 47.6627 45.4924C47.5316 45.6233 47.4005 45.7448 47.2554 45.857C46.8996 45.226 46.5064 44.4689 46.4736 44.1744C46.4783 44.1791 47.2648 44.8288 47.8593 45.2914Z",
    fill: "url(#paint239_radial_578_447492)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8339 44.6653L45.584 44.3054C45.7151 44.1418 45.8555 43.9829 46.0006 43.8334C46.0802 43.7539 46.1598 43.6791 46.244 43.6044L46.8339 44.6653Z",
    fill: "url(#paint240_radial_578_447492)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M46.834 45.661C46.4408 45.3993 46.0991 45.0628 45.8369 44.6655C46.0991 44.2729 46.4361 43.9318 46.834 43.67C47.2272 43.9318 47.5689 44.2683 47.8311 44.6655C47.5689 45.0628 47.2319 45.3993 46.834 45.661Z",
    fill: "url(#paint241_radial_578_447492)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5834 44.3753C45.7145 44.2117 45.8549 44.0528 46.0001 43.9033C46.0796 43.8238 46.1592 43.749 46.2435 43.6742C46.4307 43.5107 46.6273 43.3611 46.8333 43.2209C46.9878 43.3237 47.1376 43.4312 47.278 43.5481C47.4138 43.6602 47.5402 43.7771 47.6619 43.8986C47.9053 44.1416 48.1253 44.408 48.3172 44.6931C48.3266 44.6791 48.3313 44.6697 48.3407 44.6557C48.144 44.3566 47.9147 44.0762 47.6619 43.8238C47.5402 43.7023 47.4091 43.5854 47.278 43.4733C47.1376 43.3564 46.9878 43.2443 46.8333 43.1461C46.6273 43.2817 46.4307 43.4359 46.2435 43.5995C46.1592 43.6742 46.0796 43.749 46.0001 43.8285C45.8503 43.978 45.7098 44.1323 45.5834 44.3005C45.4898 44.4174 45.4056 44.5389 45.3213 44.6604C45.3307 44.6744 45.3353 44.6838 45.3447 44.6978C45.4243 44.5903 45.5039 44.4828 45.5834 44.3753Z",
    fill: "url(#paint242_radial_578_447492)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8583 45.2214C47.8489 45.2307 47.8396 45.2447 47.8255 45.2541C47.774 45.3102 47.7179 45.3662 47.6617 45.4223C47.5306 45.5532 47.3995 45.6747 47.2544 45.7869C47.1187 45.8991 46.9782 46.0019 46.8284 46.1C46.6037 45.9505 46.3931 45.7869 46.1918 45.6093C45.8688 45.3195 45.5832 44.9924 45.3398 44.6278C45.3304 44.6418 45.3211 44.6512 45.3164 44.6652C45.3258 44.6792 45.3351 44.6886 45.3398 44.7026C45.5832 45.0625 45.8688 45.3896 46.1918 45.6841C46.3884 45.8617 46.6037 46.0299 46.8284 46.1748C46.9735 46.0767 47.1187 45.9738 47.2544 45.8617C47.3949 45.7448 47.5306 45.6233 47.6617 45.4971C47.7179 45.441 47.7693 45.3849 47.8255 45.3289C47.8349 45.3195 47.8442 45.3055 47.8583 45.2961C48.0362 45.0999 48.1953 44.8895 48.3451 44.6699C48.3358 44.6558 48.3264 44.6465 48.3217 44.6325C48.1813 44.8381 48.0268 45.0344 47.8583 45.2214Z",
    fill: "url(#paint243_radial_578_447492)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 43.9033C45.8549 44.0528 45.7145 44.2117 45.5834 44.3753L45.3668 44.6679C45.6043 45.0164 45.8807 45.3302 46.1918 45.6093C46.3931 45.7869 46.6037 45.9505 46.8284 46.1C46.9782 46.0019 47.1187 45.8991 47.2544 45.7869C47.3995 45.6747 47.5306 45.5532 47.6617 45.4224C47.7179 45.3663 47.774 45.3102 47.8255 45.2541C47.8351 45.2477 47.8425 45.2392 47.8492 45.2314C47.8524 45.2278 47.8553 45.2244 47.8583 45.2214C48.0177 45.0446 48.1645 44.8594 48.2988 44.6659C48.1112 44.391 47.8975 44.1339 47.6619 43.8986C47.5402 43.7771 47.4138 43.6602 47.278 43.5481C47.1376 43.4312 46.9878 43.3237 46.8333 43.2209C46.6273 43.3611 46.4307 43.5107 46.2435 43.6742C46.1592 43.749 46.0796 43.8238 46 43.9033ZM48.338 44.6598C48.3388 44.6585 48.3397 44.6571 48.3406 44.6557C48.144 44.3566 47.9146 44.0762 47.6619 43.8238C47.5402 43.7023 47.4091 43.5854 47.278 43.4733C47.1376 43.3564 46.9878 43.2443 46.8333 43.1461C46.6273 43.2817 46.4307 43.4359 46.2435 43.5995C46.1592 43.6742 46.0796 43.749 46 43.8285C45.8502 43.978 45.7098 44.1323 45.5834 44.3005C45.4974 44.4079 45.4193 44.5192 45.3418 44.6308C45.3411 44.6298 45.3405 44.6288 45.3398 44.6278C45.337 44.632 45.3342 44.6358 45.3316 44.6394C45.3253 44.6479 45.3197 44.6554 45.3164 44.6652C45.3192 44.6694 45.322 44.6732 45.3247 44.6768C45.3309 44.6852 45.3365 44.6928 45.3398 44.7026C45.5832 45.0625 45.8688 45.3896 46.1918 45.6841C46.3884 45.8617 46.6037 46.0299 46.8284 46.1748C46.9735 46.0767 47.1187 45.9739 47.2544 45.8617C47.3949 45.7448 47.5306 45.6233 47.6617 45.4971C47.6898 45.4691 47.7167 45.4411 47.7436 45.413C47.7705 45.385 47.7974 45.3569 47.8255 45.3289C47.8285 45.3259 47.8314 45.3225 47.8346 45.3189C47.8413 45.3111 47.8487 45.3026 47.8583 45.2962C48.0362 45.0999 48.1953 44.8896 48.3451 44.6699C48.3427 44.6663 48.3403 44.663 48.338 44.6598Z",
    fill: "url(#paint244_radial_578_447492)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M46.834 43.6738C46.834 43.6738 47.4238 44.043 47.8311 44.6693C47.8311 44.6646 47.5408 44.0197 46.834 43.6738Z",
    fill: "url(#paint245_radial_578_447492)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8408 44.6656C45.8408 44.6656 46.1919 45.2826 46.7864 45.6518L46.8332 46.1005L46.866 45.6424C46.866 45.6424 47.3107 45.4555 47.8303 44.6656C47.8303 44.6656 47.175 45.5443 46.8239 45.591C46.8239 45.5957 46.4166 45.4368 45.8408 44.6656Z",
    fill: "url(#paint246_radial_578_447492)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8379 45.6564C46.8379 45.6564 47.4558 45.3058 47.8256 44.7123L48.275 44.6655L47.8163 44.6328C47.8163 44.6328 47.629 44.1888 46.8379 43.67C46.8379 43.67 47.718 44.3244 47.7648 44.6749C47.7694 44.6749 47.6103 45.0815 46.8379 45.6564Z",
    fill: "url(#paint247_radial_578_447492)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8151 43.67C46.8151 43.67 46.1971 44.0206 45.8273 44.6141L45.3779 44.6609L45.8367 44.6936C45.8367 44.6936 46.0239 45.1376 46.8151 45.6564C46.8151 45.6564 45.935 45.002 45.8882 44.6515C45.8835 44.6515 46.0427 44.2449 46.8151 43.67Z",
    fill: "url(#paint248_radial_578_447492)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8303 44.6602C47.8303 44.6602 47.4792 44.0432 46.8847 43.674L46.8379 43.2253L46.8051 43.6834C46.8051 43.6834 46.3604 43.8703 45.8408 44.6602C45.8408 44.6602 46.4962 43.7815 46.8473 43.7348C46.8473 43.7301 47.2545 43.889 47.8303 44.6602Z",
    fill: "url(#paint249_radial_578_447492)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2228 41.9323C54.2722 42.0039 54.2721 42.0984 54.2226 42.1699C54.0483 42.4219 53.8559 42.6638 53.6493 42.8916C53.6367 42.9041 53.6241 42.923 53.6053 42.9355C53.5361 43.0108 53.4607 43.086 53.3853 43.1613C53.2093 43.3369 53.0333 43.5 52.8385 43.6505C52.6927 43.7709 52.5428 43.8833 52.3858 43.9909C52.3139 44.04 52.2193 44.0398 52.1489 43.9886C51.8471 43.7694 51.4249 43.4052 51.0654 43.041C50.7724 42.7441 50.4739 42.3617 50.328 42.1684C50.2724 42.0948 50.2714 41.9943 50.3248 41.919C50.402 41.8101 50.5131 41.6557 50.5883 41.562C50.7643 41.3425 50.9529 41.1292 51.1477 40.9285C51.2546 40.8219 51.3614 40.7215 51.4745 40.6212C51.6893 40.4337 51.9131 40.26 52.1462 40.096C52.2185 40.0452 52.3148 40.0446 52.3877 40.0947C52.5523 40.2078 52.712 40.3258 52.8636 40.4518C53.0459 40.6024 53.2156 40.7592 53.379 40.9222C53.696 41.2442 53.9772 41.5763 54.2228 41.9323Z",
    fill: "#FFD1B2"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2228 41.9323C54.2722 42.0039 54.2721 42.0984 54.2226 42.1699C54.0483 42.4219 53.8559 42.6638 53.6493 42.8916C53.6367 42.9041 53.6241 42.923 53.6053 42.9355C53.5361 43.0108 53.4607 43.086 53.3853 43.1613C53.2093 43.3369 53.0333 43.5 52.8385 43.6505C52.6927 43.7709 52.5428 43.8833 52.3858 43.9909C52.3139 44.04 52.2193 44.0398 52.1489 43.9886C51.8471 43.7694 51.4249 43.4052 51.0654 43.041C50.7724 42.7441 50.4739 42.3617 50.328 42.1684C50.2724 42.0948 50.2714 41.9943 50.3248 41.919C50.402 41.8101 50.5131 41.6557 50.5883 41.562C50.7643 41.3425 50.9529 41.1292 51.1477 40.9285C51.2546 40.8219 51.3614 40.7215 51.4745 40.6212C51.6893 40.4337 51.9131 40.26 52.1462 40.096C52.2185 40.0452 52.3148 40.0446 52.3877 40.0947C52.5523 40.2078 52.712 40.3258 52.8636 40.4518C53.0459 40.6024 53.2156 40.7592 53.379 40.9222C53.696 41.2442 53.9772 41.5763 54.2228 41.9323Z",
    fill: "#FED3B6"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7817 42.049C53.6365 42.2686 53.4727 42.479 53.2948 42.6753C53.2854 42.6846 53.2761 42.6986 53.262 42.708C53.2106 42.764 53.1544 42.8201 53.0982 42.8762C52.9671 43.0071 52.8361 43.1286 52.6909 43.2408C52.5552 43.3529 52.4147 43.4558 52.265 43.5539C52.0403 43.4043 51.8296 43.2408 51.6283 43.0632C51.3053 42.7734 51.0198 42.4462 50.7763 42.0817C50.767 42.0677 50.7576 42.0583 50.7529 42.0443C50.8372 41.9228 50.9215 41.8013 51.0151 41.6844C51.1461 41.5208 51.2866 41.3619 51.4317 41.2124C51.5113 41.1329 51.5909 41.0582 51.6751 40.9834C51.8624 40.8198 52.059 40.6702 52.265 40.53C52.4194 40.6329 52.5692 40.7403 52.7097 40.8572C52.8454 40.9694 52.9718 41.0862 53.0935 41.2077C53.3557 41.4741 53.585 41.7499 53.7817 42.049Z",
    fill: "url(#paint250_radial_578_447492)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7825 42.0492H52.2705V40.5443C52.5701 40.7406 52.851 40.9696 53.1038 41.222C53.3565 41.4744 53.5859 41.7501 53.7825 42.0492Z",
    fill: "url(#paint251_radial_578_447492)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2698 40.5443V42.0539H50.7578C50.9544 41.7548 51.1838 41.4744 51.4366 41.222C51.694 40.9696 51.9702 40.7406 52.2698 40.5443Z",
    fill: "url(#paint252_radial_578_447492)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2698 42.0493V43.5589C51.6706 43.1617 51.1557 42.6475 50.7578 42.0493H52.2698Z",
    fill: "url(#paint253_radial_578_447492)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7825 42.0493C53.5859 42.3484 53.3565 42.6289 53.1038 42.8812C52.851 43.1336 52.5701 43.3626 52.2705 43.5589V42.0493H53.7825Z",
    fill: "url(#paint254_radial_578_447492)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7813 42.049C53.5847 42.3481 53.3553 42.6285 53.1025 42.8809C52.8497 43.1333 52.5688 43.3623 52.2692 43.5586C52.0445 43.409 51.965 43.3576 51.7637 43.18L52.714 40.8712C52.8497 40.9834 52.9761 41.1002 53.0978 41.2217C53.3553 41.4741 53.5847 41.7499 53.7813 42.049Z",
    fill: "url(#paint255_radial_578_447492)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M53.267 42.7123C53.2155 42.7684 53.1593 42.8245 53.1031 42.8806C52.8503 43.133 52.5695 43.362 52.2699 43.5583C52.0452 43.4087 51.8345 43.2451 51.6332 43.0675C51.3102 42.7778 51.0247 42.4506 50.7812 42.0861C51.4132 42.273 52.3401 42.5301 53.267 42.7123Z",
    fill: "url(#paint256_radial_578_447492)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2958 42.6754C53.2864 42.6847 53.2771 42.6987 53.263 42.7081C53.2115 42.7642 53.1554 42.8202 53.0992 42.8763C52.9681 43.0072 52.837 43.1287 52.6919 43.2409C52.3361 42.6099 51.9429 41.8528 51.9102 41.5583C51.9148 41.563 52.7013 42.2127 53.2958 42.6754Z",
    fill: "url(#paint257_radial_578_447492)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2704 42.0492L51.0205 41.6893C51.1516 41.5258 51.292 41.3668 51.4371 41.2173C51.5167 41.1378 51.5963 41.0631 51.6806 40.9883L52.2704 42.0492Z",
    fill: "url(#paint258_radial_578_447492)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2705 43.0449C51.8773 42.7832 51.5356 42.4467 51.2734 42.0495C51.5356 41.6569 51.8726 41.3157 52.2705 41.054C52.6637 41.3157 53.0055 41.6522 53.2676 42.0495C53.0055 42.4467 52.6684 42.7832 52.2705 43.0449Z",
    fill: "url(#paint259_radial_578_447492)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M51.02 41.7592C51.151 41.5956 51.2915 41.4367 51.4366 41.2872C51.5162 41.2077 51.5957 41.1329 51.68 41.0582C51.8673 40.8946 52.0639 40.745 52.2698 40.6048C52.4243 40.7076 52.5741 40.8151 52.7145 40.932C52.8503 41.0441 52.9767 41.161 53.0984 41.2825C53.3418 41.5255 53.5618 41.7919 53.7538 42.077C53.7631 42.063 53.7678 42.0536 53.7772 42.0396C53.5806 41.7405 53.3512 41.4601 53.0984 41.2077C52.9767 41.0862 52.8456 40.9694 52.7145 40.8572C52.5741 40.7403 52.4243 40.6282 52.2698 40.53C52.0639 40.6656 51.8673 40.8198 51.68 40.9834C51.5957 41.0582 51.5162 41.1329 51.4366 41.2124C51.2868 41.3619 51.1463 41.5162 51.02 41.6844C50.9263 41.8013 50.8421 41.9228 50.7578 42.0443C50.7672 42.0583 50.7719 42.0677 50.7812 42.0817C50.8608 41.9742 50.9404 41.8667 51.02 41.7592Z",
    fill: "url(#paint260_radial_578_447492)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2948 42.6053C53.2854 42.6146 53.2761 42.6286 53.262 42.638C53.2106 42.6941 53.1544 42.7502 53.0982 42.8062C52.9671 42.9371 52.8361 43.0586 52.6909 43.1708C52.5552 43.283 52.4147 43.3858 52.265 43.4839C52.0403 43.3344 51.8296 43.1708 51.6283 42.9932C51.3053 42.7034 51.0198 42.3763 50.7763 42.0117C50.767 42.0257 50.7576 42.0351 50.7529 42.0491C50.7623 42.0631 50.7717 42.0725 50.7763 42.0865C51.0198 42.4464 51.3053 42.7735 51.6283 43.068C51.8249 43.2456 52.0403 43.4138 52.265 43.5587C52.4101 43.4606 52.5552 43.3577 52.6909 43.2456C52.8314 43.1287 52.9671 43.0072 53.0982 42.881C53.1544 42.8249 53.2059 42.7689 53.262 42.7128C53.2714 42.7034 53.2808 42.6894 53.2948 42.6801C53.4727 42.4838 53.6319 42.2734 53.7817 42.0538C53.7723 42.0398 53.7629 42.0304 53.7582 42.0164C53.6178 42.222 53.4633 42.4183 53.2948 42.6053Z",
    fill: "url(#paint261_radial_578_447492)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4366 41.2872C51.2914 41.4367 51.151 41.5956 51.0199 41.7592L50.8033 42.0518C51.0408 42.4003 51.3172 42.7141 51.6283 42.9932C51.8296 43.1708 52.0403 43.3344 52.265 43.484C52.4147 43.3858 52.5552 43.283 52.6909 43.1708C52.8361 43.0587 52.9671 42.9371 53.0982 42.8063C53.1544 42.7502 53.2106 42.6941 53.262 42.638C53.2716 42.6316 53.2791 42.6231 53.2858 42.6153C53.2889 42.6117 53.2918 42.6083 53.2948 42.6053C53.4542 42.4285 53.601 42.2433 53.7353 42.0498C53.5478 41.7749 53.334 41.5178 53.0984 41.2825C52.9767 41.161 52.8503 41.0441 52.7145 40.932C52.5741 40.8151 52.4243 40.7076 52.2698 40.6048C52.0638 40.745 51.8672 40.8946 51.68 41.0582C51.5957 41.1329 51.5161 41.2077 51.4366 41.2872ZM53.7745 42.0437C53.7753 42.0424 53.7762 42.041 53.7772 42.0396C53.5805 41.7405 53.3512 41.4601 53.0984 41.2077C52.9767 41.0862 52.8456 40.9694 52.7145 40.8572C52.5741 40.7403 52.4243 40.6282 52.2698 40.53C52.0638 40.6656 51.8672 40.8198 51.68 40.9834C51.5957 41.0582 51.5161 41.1329 51.4366 41.2124C51.2868 41.3619 51.1463 41.5162 51.0199 41.6844C50.9339 41.7918 50.8558 41.9031 50.7783 42.0147C50.7777 42.0137 50.777 42.0127 50.7763 42.0117C50.7735 42.0159 50.7707 42.0197 50.7681 42.0233C50.7618 42.0318 50.7562 42.0393 50.7529 42.0491C50.7557 42.0533 50.7585 42.0571 50.7612 42.0607C50.7675 42.0692 50.7731 42.0767 50.7763 42.0865C51.0198 42.4464 51.3053 42.7736 51.6283 43.068C51.8249 43.2456 52.0403 43.4139 52.265 43.5587C52.4101 43.4606 52.5552 43.3578 52.6909 43.2456C52.8314 43.1288 52.9671 43.0072 53.0982 42.8811C53.1263 42.853 53.1532 42.825 53.1801 42.7969C53.207 42.7689 53.234 42.7408 53.262 42.7128C53.265 42.7098 53.268 42.7064 53.2711 42.7028C53.2778 42.695 53.2852 42.6865 53.2948 42.6801C53.4727 42.4838 53.6319 42.2735 53.7817 42.0538C53.7792 42.0502 53.7768 42.0469 53.7745 42.0437Z",
    fill: "url(#paint262_radial_578_447492)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2705 41.0577C52.2705 41.0577 52.8603 41.427 53.2676 42.0532C53.2676 42.0486 52.9774 41.4036 52.2705 41.0577Z",
    fill: "url(#paint263_radial_578_447492)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2773 42.0496C51.2773 42.0496 51.6284 42.6665 52.2229 43.0357L52.2698 43.4844L52.3025 43.0264C52.3025 43.0264 52.7472 42.8394 53.2668 42.0496C53.2668 42.0496 52.6115 42.9282 52.2604 42.9749C52.2604 42.9796 51.8531 42.8207 51.2773 42.0496Z",
    fill: "url(#paint264_radial_578_447492)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2744 43.0403C52.2744 43.0403 52.8923 42.6897 53.2621 42.0962L53.7115 42.0495L53.2528 42.0167C53.2528 42.0167 53.0655 41.5727 52.2744 41.054C52.2744 41.054 53.1545 41.7083 53.2013 42.0588C53.206 42.0588 53.0468 42.4654 52.2744 43.0403Z",
    fill: "url(#paint265_radial_578_447492)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2516 41.054C52.2516 41.054 51.6337 41.4045 51.2638 41.998L50.8145 42.0448L51.2732 42.0775C51.2732 42.0775 51.4605 42.5215 52.2516 43.0403C52.2516 43.0403 51.3715 42.386 51.3247 42.0354C51.32 42.0354 51.4792 41.6288 52.2516 41.054Z",
    fill: "url(#paint266_radial_578_447492)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2668 42.0441C53.2668 42.0441 52.9158 41.4271 52.3212 41.0579L52.2744 40.6093L52.2417 41.0673C52.2417 41.0673 51.797 41.2542 51.2773 42.0441C51.2773 42.0441 51.9327 41.1654 52.2838 41.1187C52.2838 41.114 52.6911 41.2729 53.2668 42.0441Z",
    fill: "url(#paint267_radial_578_447492)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6584 39.4575C59.7078 39.5291 59.7077 39.6237 59.6582 39.6952C59.4839 39.9471 59.2914 40.189 59.0848 40.4169C59.0723 40.4294 59.0597 40.4482 59.0408 40.4608C58.9717 40.536 58.8963 40.6113 58.8208 40.6866C58.6448 40.8622 58.4689 41.0252 58.274 41.1758C58.1282 41.2962 57.9784 41.4086 57.8213 41.5161C57.7495 41.5653 57.6549 41.565 57.5844 41.5139C57.2826 41.2947 56.8605 40.9305 56.5009 40.5662C56.2079 40.2694 55.9094 39.8869 55.7635 39.6937C55.708 39.6201 55.707 39.5195 55.7603 39.4443C55.8375 39.3354 55.9487 39.181 56.0239 39.0872C56.1998 38.8677 56.3884 38.6545 56.5833 38.4538C56.6901 38.3472 56.797 38.2468 56.9101 38.1465C57.1248 37.959 57.3487 37.7852 57.5817 37.6213C57.6541 37.5704 57.7504 37.5699 57.8233 37.62C57.9878 37.7331 58.1476 37.8511 58.2992 37.9771C58.4814 38.1276 58.6511 38.2844 58.8146 38.4475C59.1315 38.7694 59.4128 39.1015 59.6584 39.4575Z",
    fill: "#FFD1B2"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6584 39.4575C59.7078 39.5291 59.7077 39.6237 59.6582 39.6952C59.4839 39.9471 59.2914 40.189 59.0848 40.4169C59.0723 40.4294 59.0597 40.4482 59.0408 40.4608C58.9717 40.536 58.8963 40.6113 58.8208 40.6866C58.6448 40.8622 58.4689 41.0252 58.274 41.1758C58.1282 41.2962 57.9784 41.4086 57.8213 41.5161C57.7495 41.5653 57.6549 41.565 57.5844 41.5139C57.2826 41.2947 56.8605 40.9305 56.5009 40.5662C56.2079 40.2694 55.9094 39.8869 55.7635 39.6937C55.708 39.6201 55.707 39.5195 55.7603 39.4443C55.8375 39.3354 55.9487 39.181 56.0239 39.0872C56.1998 38.8677 56.3884 38.6545 56.5833 38.4538C56.6901 38.3472 56.797 38.2468 56.9101 38.1465C57.1248 37.959 57.3487 37.7852 57.5817 37.6213C57.6541 37.5704 57.7504 37.5699 57.8233 37.62C57.9878 37.7331 58.1476 37.8511 58.2992 37.9771C58.4814 38.1276 58.6511 38.2844 58.8146 38.4475C59.1315 38.7694 59.4128 39.1015 59.6584 39.4575Z",
    fill: "#FED3B6"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2172 39.5742C59.0721 39.7939 58.9082 40.0042 58.7304 40.2005C58.721 40.2099 58.7116 40.2239 58.6976 40.2332C58.6461 40.2893 58.5899 40.3454 58.5337 40.4015C58.4027 40.5323 58.2716 40.6539 58.1265 40.766C57.9907 40.8782 57.8503 40.981 57.7005 41.0792C57.4758 40.9296 57.2651 40.766 57.0639 40.5884C56.7409 40.2987 56.4553 39.9715 56.2119 39.607C56.2025 39.5929 56.1932 39.5836 56.1885 39.5696C56.2727 39.4481 56.357 39.3265 56.4506 39.2097C56.5817 39.0461 56.7221 38.8872 56.8672 38.7377C56.9468 38.6582 57.0264 38.5834 57.1107 38.5086C57.2979 38.3451 57.4945 38.1955 57.7005 38.0553C57.855 38.1581 58.0048 38.2656 58.1452 38.3825C58.281 38.4946 58.4074 38.6115 58.5291 38.733C58.7912 38.9994 59.0206 39.2751 59.2172 39.5742Z",
    fill: "url(#paint268_radial_578_447492)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2181 39.5745H57.7061V38.0696C58.0057 38.2659 58.2865 38.4949 58.5393 38.7473C58.7921 38.9996 59.0215 39.2754 59.2181 39.5745Z",
    fill: "url(#paint269_radial_578_447492)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7054 38.0696V39.5792H56.1934C56.39 39.2801 56.6193 38.9996 56.8721 38.7473C57.1296 38.4949 57.4058 38.2659 57.7054 38.0696Z",
    fill: "url(#paint270_radial_578_447492)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7054 39.5746V41.0842C57.1062 40.6869 56.5913 40.1728 56.1934 39.5746H57.7054Z",
    fill: "url(#paint271_radial_578_447492)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2181 39.5746C59.0215 39.8737 58.7921 40.1541 58.5393 40.4065C58.2865 40.6589 58.0057 40.8879 57.7061 41.0842V39.5746H59.2181Z",
    fill: "url(#paint272_radial_578_447492)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2168 39.5743C59.0202 39.8734 58.7908 40.1538 58.538 40.4062C58.2853 40.6585 58.0044 40.8876 57.7048 41.0839C57.4801 40.9343 57.4005 40.8829 57.1992 40.7053L58.1495 38.3965C58.2853 38.5087 58.4116 38.6255 58.5334 38.747C58.7908 38.9994 59.0202 39.2751 59.2168 39.5743Z",
    fill: "url(#paint273_radial_578_447492)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7025 40.2376C58.651 40.2937 58.5948 40.3498 58.5387 40.4059C58.2859 40.6582 58.005 40.8872 57.7054 41.0835C57.4807 40.934 57.2701 40.7704 57.0688 40.5928C56.7458 40.303 56.4602 39.9759 56.2168 39.6113C56.8488 39.7983 57.7756 40.0553 58.7025 40.2376Z",
    fill: "url(#paint274_radial_578_447492)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 40.2006C58.722 40.21 58.7126 40.224 58.6986 40.2333C58.6471 40.2894 58.5909 40.3455 58.5347 40.4016C58.4037 40.5325 58.2726 40.654 58.1275 40.7661C57.7717 40.1352 57.3785 39.3781 57.3457 39.0836C57.3504 39.0883 58.1368 39.7379 58.7313 40.2006Z",
    fill: "url(#paint275_radial_578_447492)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7059 39.5745L56.4561 39.2146C56.5871 39.051 56.7276 38.8921 56.8727 38.7426C56.9523 38.6631 57.0318 38.5883 57.1161 38.5135L57.7059 39.5745Z",
    fill: "url(#paint276_radial_578_447492)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7061 40.5702C57.3129 40.3085 56.9711 39.972 56.709 39.5747C56.9711 39.1821 57.3082 38.8409 57.7061 38.5792C58.0993 38.8409 58.441 39.1775 58.7032 39.5747C58.441 39.972 58.104 40.3085 57.7061 40.5702Z",
    fill: "url(#paint277_radial_578_447492)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4555 39.2845C56.5866 39.1209 56.727 38.962 56.8721 38.8124C56.9517 38.733 57.0313 38.6582 57.1156 38.5834C57.3028 38.4198 57.4994 38.2703 57.7054 38.1301C57.8599 38.2329 58.0097 38.3404 58.1501 38.4572C58.2858 38.5694 58.4122 38.6862 58.5339 38.8078C58.7774 39.0508 58.9974 39.3172 59.1893 39.6023C59.1987 39.5883 59.2034 39.5789 59.2127 39.5649C59.0161 39.2658 58.7867 38.9854 58.5339 38.733C58.4122 38.6115 58.2812 38.4946 58.1501 38.3825C58.0097 38.2656 57.8599 38.1534 57.7054 38.0553C57.4994 38.1908 57.3028 38.3451 57.1156 38.5086C57.0313 38.5834 56.9517 38.6582 56.8721 38.7377C56.7223 38.8872 56.5819 39.0414 56.4555 39.2097C56.3619 39.3265 56.2776 39.4481 56.1934 39.5696C56.2027 39.5836 56.2074 39.5929 56.2168 39.607C56.2963 39.4995 56.3759 39.392 56.4555 39.2845Z",
    fill: "url(#paint278_radial_578_447492)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7304 40.1305C58.721 40.1399 58.7116 40.1539 58.6976 40.1633C58.6461 40.2193 58.5899 40.2754 58.5337 40.3315C58.4027 40.4624 58.2716 40.5839 58.1265 40.6961C57.9907 40.8082 57.8503 40.9111 57.7005 41.0092C57.4758 40.8596 57.2651 40.6961 57.0639 40.5185C56.7409 40.2287 56.4553 39.9015 56.2119 39.537C56.2025 39.551 56.1932 39.5604 56.1885 39.5744C56.1978 39.5884 56.2072 39.5977 56.2119 39.6118C56.4553 39.9716 56.7409 40.2988 57.0639 40.5932C57.2605 40.7708 57.4758 40.9391 57.7005 41.084C57.8456 40.9858 57.9907 40.883 58.1265 40.7708C58.2669 40.654 58.4027 40.5325 58.5337 40.4063C58.5899 40.3502 58.6414 40.2941 58.6976 40.238C58.707 40.2287 58.7163 40.2147 58.7304 40.2053C58.9082 40.009 59.0674 39.7987 59.2172 39.5791C59.2078 39.565 59.1985 39.5557 59.1938 39.5417C59.0534 39.7473 58.8989 39.9436 58.7304 40.1305Z",
    fill: "url(#paint279_radial_578_447492)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8721 38.8124C56.727 38.962 56.5866 39.1209 56.4555 39.2845L56.2389 39.5771C56.4763 39.9256 56.7527 40.2394 57.0639 40.5185C57.2651 40.6961 57.4758 40.8597 57.7005 41.0092C57.8503 40.9111 57.9907 40.8083 58.1265 40.6961C58.2716 40.5839 58.4027 40.4624 58.5337 40.3315C58.5899 40.2755 58.6461 40.2194 58.6976 40.1633C58.7072 40.1569 58.7146 40.1483 58.7213 40.1406C58.7244 40.137 58.7274 40.1335 58.7304 40.1306C58.8897 39.9538 59.0366 39.7686 59.1708 39.575C58.9833 39.3002 58.7696 39.043 58.5339 38.8078C58.4122 38.6862 58.2858 38.5694 58.1501 38.4572C58.0096 38.3404 57.8598 38.2329 57.7054 38.1301C57.4994 38.2703 57.3028 38.4198 57.1155 38.5834C57.0313 38.6582 56.9517 38.733 56.8721 38.8124ZM59.21 39.569C59.2109 39.5677 59.2118 39.5663 59.2127 39.5649C59.0161 39.2658 58.7867 38.9854 58.5339 38.733C58.4122 38.6115 58.2811 38.4946 58.1501 38.3825C58.0096 38.2656 57.8598 38.1534 57.7054 38.0553C57.4994 38.1908 57.3028 38.3451 57.1155 38.5086C57.0313 38.5834 56.9517 38.6582 56.8721 38.7377C56.7223 38.8872 56.5819 39.0414 56.4555 39.2097C56.3695 39.3171 56.2913 39.4284 56.2139 39.54C56.2132 39.539 56.2125 39.538 56.2119 39.537C56.2091 39.5412 56.2063 39.545 56.2036 39.5486C56.1973 39.557 56.1918 39.5646 56.1885 39.5744C56.1913 39.5786 56.1941 39.5824 56.1967 39.586C56.203 39.5944 56.2086 39.602 56.2119 39.6118C56.4553 39.9717 56.7409 40.2988 57.0639 40.5933C57.2605 40.7709 57.4758 40.9391 57.7005 41.084C57.8456 40.9859 57.9907 40.883 58.1265 40.7709C58.2669 40.654 58.4027 40.5325 58.5337 40.4063C58.5618 40.3783 58.5888 40.3502 58.6157 40.3222C58.6426 40.2942 58.6695 40.2661 58.6976 40.2381C58.7006 40.2351 58.7035 40.2317 58.7066 40.2281C58.7134 40.2203 58.7208 40.2117 58.7304 40.2054C58.9082 40.0091 59.0674 39.7987 59.2172 39.5791C59.2148 39.5755 59.2124 39.5721 59.21 39.569Z",
    fill: "url(#paint280_radial_578_447492)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7061 38.583C57.7061 38.583 58.2959 38.9522 58.7031 39.5785C58.7031 39.5738 58.4129 38.9289 57.7061 38.583Z",
    fill: "url(#paint281_radial_578_447492)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7129 39.5748C56.7129 39.5748 57.064 40.1918 57.6585 40.561L57.7053 41.0096L57.7381 40.5516C57.7381 40.5516 58.1828 40.3647 58.7024 39.5748C58.7024 39.5748 58.047 40.4535 57.6959 40.5002C57.6959 40.5049 57.2887 40.346 56.7129 39.5748Z",
    fill: "url(#paint282_radial_578_447492)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M57.71 40.5655C57.71 40.5655 58.3279 40.215 58.6977 39.6215L59.1471 39.5747L58.6883 39.542C58.6883 39.542 58.5011 39.098 57.71 38.5792C57.71 38.5792 58.59 39.2335 58.6368 39.5841C58.6415 39.5841 58.4824 39.9907 57.71 40.5655Z",
    fill: "url(#paint283_radial_578_447492)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6871 38.5792C57.6871 38.5792 57.0692 38.9298 56.6994 39.5233L56.25 39.57L56.7088 39.6028C56.7088 39.6028 56.896 40.0468 57.6871 40.5655C57.6871 40.5655 56.8071 39.9112 56.7602 39.5607C56.7556 39.5607 56.9147 39.1541 57.6871 38.5792Z",
    fill: "url(#paint284_radial_578_447492)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7024 39.5693C58.7024 39.5693 58.3513 38.9524 57.7568 38.5832L57.71 38.1345L57.6772 38.5925C57.6772 38.5925 57.2325 38.7795 56.7129 39.5693C56.7129 39.5693 57.3683 38.6907 57.7193 38.644C57.7193 38.6393 58.1266 38.7982 58.7024 39.5693Z",
    fill: "url(#paint285_radial_578_447492)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7744 21.7148C44.0891 21.7269 44.3554 21.7511 44.5854 21.7633C44.8033 21.7754 44.9849 21.7754 45.118 21.7754C45.2754 21.7754 45.6022 21.7632 46.0864 21.739C46.268 21.7269 46.4133 21.727 46.498 21.727V22.1143C46.2317 22.1264 46.0501 22.1627 45.9654 22.199C45.8806 22.2353 45.8443 22.3201 45.8443 22.4411C45.8443 22.4895 45.8564 22.5622 45.8685 22.6348C45.8806 22.7074 45.917 22.7921 45.9533 22.889L47.4785 27.2104L48.9189 22.9011C48.9674 22.7921 48.9916 22.7074 49.0037 22.659C49.0158 22.6106 49.0158 22.5379 49.0158 22.4774C49.0158 22.3443 48.9674 22.2474 48.8584 22.1869C48.7495 22.1264 48.5679 22.1022 48.3137 22.1022V21.7148C48.5558 21.7269 48.7374 21.739 48.8947 21.7511C49.0521 21.7632 49.1731 21.7633 49.2821 21.7633C49.3668 21.7633 49.4758 21.7632 49.6089 21.7511C49.7421 21.739 49.9357 21.7391 50.1778 21.7148V22.1022C49.9478 22.1143 49.7905 22.1627 49.7057 22.2232C49.621 22.2837 49.5484 22.3806 49.5121 22.5258L47.9506 27.0167C47.8537 27.283 47.7569 27.5614 47.6479 27.8519C47.539 28.1424 47.4301 28.4451 47.309 28.7477L46.8248 28.6992L44.5733 22.7316L44.5612 22.6953C44.416 22.2959 44.1618 22.1022 43.7986 22.1022L43.7744 21.7148Z",
    fill: "url(#paint286_radial_578_447492)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7744 21.7148C44.0891 21.7269 44.3554 21.7511 44.5854 21.7633C44.8033 21.7754 44.9849 21.7754 45.118 21.7754C45.2754 21.7754 45.6022 21.7632 46.0864 21.739C46.268 21.7269 46.4133 21.727 46.498 21.727V22.1143C46.2317 22.1264 46.0501 22.1627 45.9654 22.199C45.8806 22.2353 45.8443 22.3201 45.8443 22.4411C45.8443 22.4895 45.8564 22.5622 45.8685 22.6348C45.8806 22.7074 45.917 22.7921 45.9533 22.889L47.4785 27.2104L48.9189 22.9011C48.9674 22.7921 48.9916 22.7074 49.0037 22.659C49.0158 22.6106 49.0158 22.5379 49.0158 22.4774C49.0158 22.3443 48.9674 22.2474 48.8584 22.1869C48.7495 22.1264 48.5679 22.1022 48.3137 22.1022V21.7148C48.5558 21.7269 48.7374 21.739 48.8947 21.7511C49.0521 21.7632 49.1731 21.7633 49.2821 21.7633C49.3668 21.7633 49.4758 21.7632 49.6089 21.7511C49.7421 21.739 49.9357 21.7391 50.1778 21.7148V22.1022C49.9478 22.1143 49.7905 22.1627 49.7057 22.2232C49.621 22.2837 49.5484 22.3806 49.5121 22.5258L47.9506 27.0167C47.8537 27.283 47.7569 27.5614 47.6479 27.8519C47.539 28.1424 47.4301 28.4451 47.309 28.7477L46.8248 28.6992L44.5733 22.7316L44.5612 22.6953C44.416 22.2959 44.1618 22.1022 43.7986 22.1022L43.7744 21.7148Z",
    fill: "url(#paint287_radial_578_447492)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6094 21.7148C43.9241 21.7269 44.1904 21.7511 44.4204 21.7633C44.6383 21.7754 44.8198 21.7754 44.953 21.7754C45.1104 21.7754 45.4372 21.7632 45.9214 21.739C46.103 21.7269 46.2482 21.727 46.3329 21.727V22.1143C46.0666 22.1264 45.8851 22.1627 45.8003 22.199C45.7156 22.2353 45.6793 22.3201 45.6793 22.4411C45.6793 22.4895 45.6914 22.5622 45.7035 22.6348C45.7156 22.7074 45.7519 22.7921 45.7882 22.889L47.3134 27.2104L48.7539 22.9011C48.8023 22.7921 48.8265 22.7074 48.8386 22.659C48.8507 22.6106 48.8507 22.5379 48.8507 22.4774C48.8507 22.3443 48.8023 22.2474 48.6934 22.1869C48.5844 22.1264 48.4029 22.1022 48.1487 22.1022V21.7148C48.3908 21.7269 48.5723 21.739 48.7297 21.7511C48.887 21.7632 49.0081 21.7633 49.117 21.7633C49.2018 21.7633 49.3107 21.7632 49.4439 21.7511C49.577 21.739 49.7707 21.7391 50.0128 21.7148V22.1022C49.7828 22.1143 49.6254 22.1627 49.5407 22.2232C49.456 22.2837 49.3833 22.3806 49.347 22.5258L47.7855 27.0167C47.6887 27.283 47.5918 27.5614 47.4829 27.8519C47.374 28.1424 47.265 28.4451 47.144 28.7477L46.6598 28.6992L44.4083 22.7316L44.3962 22.6953C44.2509 22.2959 43.9967 22.1022 43.6336 22.1022L43.6094 21.7148Z",
    fill: "url(#paint288_radial_578_447492)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7617 21.7148C44.0764 21.7269 44.3427 21.7511 44.5727 21.7633C44.7906 21.7754 44.9722 21.7754 45.1053 21.7754C45.2627 21.7754 45.5895 21.7632 46.0737 21.739C46.2553 21.7269 46.4006 21.727 46.4853 21.727V22.1143C46.219 22.1264 46.0374 22.1627 45.9527 22.199C45.8679 22.2353 45.8316 22.3201 45.8316 22.4411C45.8316 22.4895 45.8437 22.5622 45.8558 22.6348C45.8679 22.7074 45.9043 22.7921 45.9406 22.889L47.4658 27.2104L48.9062 22.9011C48.9547 22.7921 48.9789 22.7074 48.991 22.659C49.0031 22.6106 49.0031 22.5379 49.0031 22.4774C49.0031 22.3443 48.9547 22.2474 48.8457 22.1869C48.7368 22.1264 48.5552 22.1022 48.301 22.1022V21.7148C48.5431 21.7269 48.7247 21.739 48.882 21.7511C49.0394 21.7632 49.1604 21.7633 49.2694 21.7633C49.3541 21.7633 49.4631 21.7632 49.5962 21.7511C49.7294 21.739 49.923 21.7391 50.1651 21.7148V22.1022C49.9351 22.1143 49.7778 22.1627 49.693 22.2232C49.6083 22.2837 49.5357 22.3806 49.4994 22.5258L47.9379 27.0167C47.841 27.283 47.7442 27.5614 47.6352 27.8519C47.5263 28.1424 47.4174 28.4451 47.2963 28.7477L46.8121 28.6992L44.5606 22.7316L44.5485 22.6953C44.4033 22.2959 44.1491 22.1022 43.7859 22.1022L43.7617 21.7148Z",
    fill: "url(#paint289_radial_578_447492)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3689 26.92L45.9405 22.877C45.9042 22.7802 45.88 22.6833 45.8558 22.6228C45.8316 22.5623 45.8316 22.4897 45.8316 22.4291C45.8316 22.3565 45.8437 22.296 45.88 22.2476C45.8073 22.2597 45.7589 22.2718 45.7226 22.296C45.6379 22.3444 45.6016 22.417 45.6016 22.5381C45.6016 22.5865 45.6137 22.6591 45.6258 22.7317C45.6379 22.8044 45.6742 22.8891 45.7105 22.986L47.2357 27.3073L47.3689 26.92Z",
    fill: "url(#paint290_radial_578_447492)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3427 21.8722C44.5606 21.8843 44.7422 21.8843 44.8754 21.8843C45.0327 21.8843 45.3595 21.8722 45.8437 21.848C46.0253 21.8359 46.1706 21.8359 46.2553 21.8359V22.1264C46.3279 22.1143 46.4006 22.1143 46.4853 22.1143V21.727C46.3885 21.727 46.2553 21.739 46.0737 21.739C45.5895 21.7632 45.2627 21.7754 45.1053 21.7754C44.9843 21.7754 44.8027 21.7633 44.5727 21.7633C44.3548 21.7511 44.0764 21.7391 43.7617 21.7148V21.848C43.9917 21.8601 44.1854 21.8601 44.3427 21.8722Z",
    fill: "url(#paint291_radial_578_447492)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M49.596 21.7512C49.4628 21.7633 49.3539 21.7633 49.2692 21.7633C49.1602 21.7633 49.0392 21.7633 48.8818 21.7512C48.7244 21.7391 48.5429 21.7391 48.3008 21.7149V21.8481C48.4339 21.8602 48.555 21.8601 48.6518 21.8601C48.8092 21.8722 48.9302 21.8722 49.0392 21.8722C49.1239 21.8722 49.2328 21.8722 49.366 21.8601C49.4992 21.848 49.6928 21.848 49.9349 21.8238V22.1143C50.0076 22.1022 50.0802 22.0902 50.1649 22.078V21.6907C49.9228 21.727 49.7291 21.7391 49.596 21.7512Z",
    fill: "url(#paint292_radial_578_447492)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4509 22.3319C49.3661 22.3803 49.2935 22.4893 49.2572 22.6345L47.6957 27.1253C47.5988 27.3917 47.502 27.6701 47.3931 27.9606C47.3083 28.2027 47.1994 28.4569 47.1025 28.7232L47.2841 28.7353C47.4052 28.4327 47.5141 28.1301 47.623 27.8396C47.732 27.5491 47.8288 27.2706 47.9257 27.0043L49.4872 22.5135C49.5235 22.4045 49.5719 22.3198 49.6324 22.2593C49.5598 22.2714 49.4993 22.2956 49.4509 22.3319Z",
    fill: "url(#paint293_radial_578_447492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.578 8.43052) rotate(46.3999) scale(8.51633 8.51646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E55E03"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9942 13.5353) rotate(46.3999) scale(11.7561 11.7563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8163 14.6692) rotate(46.3996) scale(8.02218 8.0223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.352 15.1311) rotate(46.4172) scale(0.166639 0.166637)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9119 13.0891) rotate(46.3997) scale(4.4365 4.43657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.92 11.3457) rotate(46.3998) scale(5.12905 5.12913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2256 8.90254) rotate(46.4008) scale(1.58637 1.58639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7802 12.9985) rotate(46.3999) scale(7.32901 7.32912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7775 12.0563) rotate(46.4005) scale(2.00776 2.00778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6493 9.14875) rotate(42.5399) scale(6.70748 6.7073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E55E03"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7477 12.7672) rotate(42.5398) scale(9.25911 9.25886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7383 13.9325) rotate(42.54) scale(6.31829 6.31812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7564 14.1612) rotate(42.5412) scale(0.131263 0.13126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.873 12.4738) rotate(42.5402) scale(3.49419 3.49409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6447 11.3152) rotate(42.54) scale(4.03965 4.03954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4694 9.0617) rotate(42.5402) scale(1.24938 1.24935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5514 12.3566) rotate(42.5397) scale(5.77235 5.77218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4994 11.6166) rotate(42.5383) scale(1.58131 1.58126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5089 8.41697) rotate(133.6) scale(8.51632 8.51645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E55E03"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0924 13.5217) rotate(133.6) scale(11.7561 11.7563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.2708 14.6556) rotate(133.6) scale(8.02218 8.0223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.735 15.1177) rotate(133.592) scale(0.166663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1759 13.0756) rotate(133.6) scale(4.43648 4.43654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1668 11.3321) rotate(133.6) scale(5.12905 5.12913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8609 8.8889) rotate(133.599) scale(1.58637 1.58639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3059 12.9849) rotate(133.6) scale(7.329 7.32912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.309 12.0426) rotate(133.599) scale(2.00775 2.00778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3631 9.19164) rotate(137.46) scale(6.70747 6.70729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E55E03"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.2645 12.8101) rotate(137.46) scale(9.25906 9.25882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2735 13.9755) rotate(137.46) scale(6.3183 6.31813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2565 14.2042) rotate(137.447) scale(0.131234 0.131235)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1395 12.5167) rotate(137.46) scale(3.49421 3.49412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.368 11.3582) rotate(137.46) scale(4.03965 4.03954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5426 9.10452) rotate(137.46) scale(1.24938 1.24934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4608 12.3995) rotate(137.46) scale(5.77231 5.77215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5139 11.6596) rotate(137.459) scale(1.58125 1.58121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0742 9.71625) scale(17.1064 10.9715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    stopColor: "#F9B946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E55E03"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6983 11.3246) scale(9.7853 6.27596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D65218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4628 11.9084) scale(12.9068 8.2781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#912A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3736 7.93727) scale(4.79586 3.07595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E55E03",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2144 10.2126) scale(4.04265 2.59293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675759,
    stopColor: "#FFF5E1",
    stopOpacity: 0.9324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3824,
    stopColor: "#FFE4AA",
    stopOpacity: 0.6176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#FFD883",
    stopOpacity: 0.3462
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#FFD16A",
    stopOpacity: 0.1314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9262 13.951) scale(11.2283 7.2015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9926 10.7248) scale(4.05118 2.5983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675759,
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3824,
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#FFD883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#FFD16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6645 9.61521) scale(4.4257 2.83852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675759,
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3824,
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#FFD883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#FFD16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0571 5.55737) scale(2.21665 1.42166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675759,
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3824,
    stopColor: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#FFD883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#FFD16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6008 12.0987) scale(6.41765 4.11613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675759,
    stopColor: "#FFF5E1",
    stopOpacity: 0.9324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3824,
    stopColor: "#FFE4AA",
    stopOpacity: 0.6176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#FFD883",
    stopOpacity: 0.3462
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    stopColor: "#FFD16A",
    stopOpacity: 0.1314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.5918 30.6737) scale(15.346 15.3412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7507A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#CA66FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    stopColor: "#7700AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8282 33.3765) scale(17.7119 17.7063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#210033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#842CAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.9954 32.6458) scale(6.26647 6.26451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.2154 35.5198) scale(3.72682 3.72562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.7387 25.8406) scale(20.0253 20.019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00202498,
    stopColor: "#A40BF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C04A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4301 32.5575) scale(16.6088 16.6036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    stopColor: "#921ADA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6617 34.5312) scale(0.0256582 0.012567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.5976 34.402) scale(12.8582 12.8542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    stopColor: "#931ADC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5268 30.0223) rotate(178.409) scale(10.3199 2.89337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9194 30.3328) rotate(87.8837) scale(12.082 8.14883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#210033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#842CAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5613 22.4247) scale(12.0987 12.0949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.7099 24.0211) scale(12.1312 12.1278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.5571 25.569) scale(2.80126 2.80045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.2576 26.9556) scale(2.62109 2.62022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.6915 26.0651) scale(25.9732 25.9652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.6083 28.0671) scale(1.00429 1.00397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.7426 26.0334) scale(5.13074 5.13141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.4301 26.3194) scale(5.13074 5.13141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.6585 26.8162) scale(1.94196 1.94136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.5342 22.8499) scale(19.0866 19.0814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.5767 26.9456) scale(3.21697 3.21605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6452 30.6741) rotate(180) scale(15.346 15.3412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7507A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#CA66FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    stopColor: "#7700AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.409 33.3769) rotate(180) scale(17.712 17.7063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#210033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#842CAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2416 32.6462) rotate(180) scale(6.26647 6.2645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.0219 35.52) rotate(180) scale(3.72682 3.72563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4983 25.841) rotate(180) scale(20.0253 20.019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00202498,
    stopColor: "#A40BF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C04A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.807 32.5577) rotate(180) scale(16.6088 16.6036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    stopColor: "#921ADA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5767 34.5299) rotate(180) scale(0.0240443 0.0117816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9969,
    stopColor: "#D5AA92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6389 34.4021) rotate(180) scale(12.8582 12.8542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    stopColor: "#931ADC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7414 30.0181) rotate(1.59086) scale(10.3199 2.89337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3469 30.3574) rotate(92.1163) scale(12.082 8.14883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#210033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#842CAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6754 22.4248) rotate(180) scale(12.0987 12.0949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5269 24.0215) rotate(180) scale(12.1312 12.1278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6792 25.569) rotate(180) scale(2.80134 2.80046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9796 26.9558) rotate(180) scale(2.62112 2.62022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA3911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF781D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5451 26.0651) rotate(180) scale(25.9733 25.9652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6291 28.0672) rotate(180) scale(1.00432 1.00397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4948 26.0338) rotate(180) scale(5.13077 5.13141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8063 26.3199) rotate(180) scale(5.13077 5.13141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5779 26.8165) rotate(180) scale(1.94196 1.94136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.703 22.8503) rotate(180) scale(19.0866 19.0814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6597 26.9457) rotate(180) scale(3.21713 3.21605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0961 17.6965) rotate(-18.9687) scale(13.3832 13.3799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2833 8.02061) rotate(-18.9687) scale(33.3426 33.3342)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8253 8.31564) rotate(-18.9687) scale(22.7192 22.7135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3032 7.56705) rotate(-18.9687) scale(22.6915 22.6857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2978 19.8987) rotate(-18.9686) scale(8.45745 8.45528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5363 16.2148) rotate(-18.9687) scale(5.10904 5.10775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.7949 14.0956) rotate(-18.9688) scale(11.1043 11.1015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.2286 15.8275) rotate(-18.9687) scale(12.2077 12.2046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_578_447492",
    x1: 62.6085,
    y1: 20.5913,
    x2: 63.4288,
    y2: 9.27271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6638 11.5868) rotate(-18.9687) scale(19.0897 19.085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.1494 8.70711) rotate(-18.9686) scale(12.6687 12.6654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.6936 8.41726) rotate(-18.9686) scale(7.3551 7.3532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C95D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.9877 26.1867) scale(15.2614 15.2565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9323 22.1708) rotate(-8.98032) scale(13.3837 13.3797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.7202 13.5412) rotate(-8.98029) scale(33.3438 33.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.2331 13.5789) rotate(-8.98029) scale(22.7201 22.7132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.7428 13.9652) rotate(-8.98029) scale(22.6923 22.6854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.824 23.5071) rotate(-8.98042) scale(8.45772 8.45527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.562 21.4814) rotate(-8.98023) scale(5.10921 5.10763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3059 18.0516) rotate(-8.98034) scale(11.1047 11.1014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4171 20.0061) rotate(-8.98029) scale(12.2081 12.2044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_578_447492",
    x1: 58.9946,
    y1: 24.4172,
    x2: 61.7658,
    y2: 13.4121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6566 15.0378) rotate(-8.98028) scale(19.0904 19.0846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4983 13.8468) rotate(-8.98034) scale(12.6691 12.6654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0249 14.3491) rotate(-8.98035) scale(7.35535 7.35317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C95D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.763 29.278) scale(16.517 16.5118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9525 26.1683) rotate(0.338095) scale(12.4243 12.4202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4675 19.2836) rotate(0.338095) scale(30.9534 30.9434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0996 19.0946) rotate(0.338095) scale(21.0913 21.0845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0044 20.4271) rotate(0.338098) scale(21.0654 21.0588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0711 26.6246) rotate(0.338234) scale(7.85138 7.85208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.2965 26.2331) rotate(0.338095) scale(4.74291 4.74139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1653 22.0003) rotate(0.338096) scale(10.3086 10.3053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8895 23.957) rotate(0.338096) scale(11.3329 11.3293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_578_447492",
    x1: 55.9937,
    y1: 27.6287,
    x2: 60.1866,
    y2: 17.9638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.192 18.8417) rotate(0.338096) scale(17.7218 17.7162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3863 19.2299) rotate(0.338099) scale(11.7609 11.7572)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4574 20.3704) rotate(0.338098) scale(6.82805 6.82591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C95D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.733 22.7972) rotate(90) scale(15.1968 5.47721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7307 17.586) rotate(-161.031) scale(13.3832 13.3799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5443 7.91027) rotate(-161.031) scale(33.3426 33.3342)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0023 8.20529) rotate(-161.031) scale(22.7192 22.7135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5236 7.45657) rotate(-161.031) scale(22.6915 22.6857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.53 19.7883) rotate(-161.031) scale(8.45741 8.45528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2914 16.1043) rotate(-161.031) scale(5.10903 5.10774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0321 13.9852) rotate(-161.031) scale(11.1043 11.1015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5991 15.717) rotate(-161.031) scale(12.2077 12.2046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_578_447492",
    x1: 31.2342,
    y1: 20.4797,
    x2: 30.4138,
    y2: 9.16112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1632 11.4764) rotate(-161.031) scale(19.0897 19.085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6782 8.59664) rotate(-161.031) scale(12.6687 12.6654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1343 8.30675) rotate(-161.032) scale(7.35517 7.35322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C95D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7278 26.1864) rotate(180) scale(15.2614 15.2565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8386 22.3031) rotate(-171.02) scale(13.3837 13.3797)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0511 13.6735) rotate(-171.02) scale(33.3437 33.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5382 13.7112) rotate(-171.02) scale(22.72 22.7132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0282 14.0974) rotate(-171.02) scale(22.6923 22.6854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9468 23.6393) rotate(-171.02) scale(8.45776 8.45527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2094 21.6136) rotate(-171.02) scale(5.10921 5.10763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4656 18.1838) rotate(-171.02) scale(11.1047 11.1014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3543 20.1382) rotate(-171.02) scale(12.2081 12.2044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_578_447492",
    x1: 34.7689,
    y1: 24.5511,
    x2: 31.9978,
    y2: 13.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.114 15.17) rotate(-171.02) scale(19.0904 19.0846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2726 13.979) rotate(-171.02) scale(12.6691 12.6654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7468 14.4815) rotate(-171.02) scale(7.35535 7.35317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C95D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9537 29.2781) rotate(180) scale(16.517 16.5118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7517 26.1679) rotate(179.662) scale(12.4242 12.4202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2358 19.2831) rotate(179.662) scale(30.9533 30.9434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6037 19.0941) rotate(179.662) scale(21.0912 21.0845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6987 20.4266) rotate(179.662) scale(21.0654 21.0588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6323 26.6241) rotate(179.662) scale(7.85138 7.85208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4067 26.2326) rotate(179.662) scale(4.74295 4.74139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5379 21.9998) rotate(179.662) scale(10.3086 10.3053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8134 23.9566) rotate(179.662) scale(11.3329 11.3293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_578_447492",
    x1: 37.7149,
    y1: 27.6257,
    x2: 33.5221,
    y2: 17.9608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5111 18.8412) rotate(179.662) scale(17.7218 17.7161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.316 19.2294) rotate(179.662) scale(11.7609 11.7571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000378867,
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2462 20.37) rotate(179.662) scale(6.82805 6.82591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C95D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9992 22.8202) rotate(90) scale(15.1968 5.4772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8683 38.2154) scale(14.9033 14.8985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#FFD48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA742A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3593 24.9409) scale(24.1566 24.149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9124"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8034 8.15014) scale(24.433 24.4251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8229 32.517) scale(13.1656 13.1614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2325 26.3485) scale(23.923 6.10256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3338 23.7319) rotate(-0.328285) scale(28.6153 6.1926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E5919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB449",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.7076 13.9417) scale(23.4083 23.4009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2178 30.9309) scale(20.6139 20.6074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_578_447492",
    x1: 46.8469,
    y1: 39.0039,
    x2: 46.8469,
    y2: 9.07169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    stopColor: "#FFAA2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683614"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5584 21.8953) scale(20.0996 20.0932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1412 19.5311) scale(21.7904 21.7835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.859 16.5859) scale(8.49205 8.48935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8557 35.0042) scale(15.9883 15.9832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_578_447492",
    x1: 46.8556,
    y1: 14.5172,
    x2: 46.8556,
    y2: 39.1231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    stopColor: "#F4C95D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54C11",
    stopOpacity: 0.9811
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8142 26.9396) scale(15.5658 15.5608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0245 30.4841) scale(14.2936 14.2891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7331 19.0037) scale(20.4148 20.4082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00129337,
    stopColor: "#9B794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_578_447492",
    x1: 47.1215,
    y1: 17.3212,
    x2: 47.1215,
    y2: 33.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5377,
    stopColor: "#5E4004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54C11",
    stopOpacity: 0.9811
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6446 18.3068) scale(18.513 18.5071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3075,
    stopColor: "#FFD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C46B12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8285 17.5606) scale(18.3598 18.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2871,
    stopColor: "#FFCE61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#FF781D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5594 20.6863) scale(11.8424 11.8387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7854 30.576) scale(8.85704 8.85423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1493 25.2421) scale(7.32932 4.9339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3609 42.5414) scale(25.0004 24.9925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7507A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#CA66FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9954,
    stopColor: "#7700AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6731 50.1856) scale(9.44737 9.44435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3671 37.7088) scale(28.5727 28.5635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00202498,
    stopColor: "#A40BF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C04A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0327 37.5039) scale(19.3566 19.3505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6045 40.4868) scale(11.2831 11.2796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B207A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7414AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3653 47.0332) scale(19.5146 19.5084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4014,
    stopColor: "#921ADA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#921ADA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_578_447492",
    x1: 46.7677,
    y1: 28.8487,
    x2: 46.7677,
    y2: 50.2715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3279,
    stopColor: "#59048A",
    stopOpacity: 0.6536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9467,
    stopColor: "#A40BF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9554 37.7577) scale(4.55744 4.55014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FFA505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6873 40.3087) scale(2.33574 2.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.204 37.9128) scale(2.27872 2.27507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.503 38.9413) scale(3.07301 3.06809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5217 40.7707) scale(1.85128 1.84831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4294 38.7512) scale(2.12397 2.12057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2792 38.866) scale(3.17594 3.17085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2411 41.9956) scale(3.25067 3.24547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6675 37.891) scale(1.95511 1.95197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9849 39.0147) scale(4.41763 4.41056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9768 37.9099) scale(2.87349 2.86889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9773 41.1343) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9773 41.1343) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6875 38.9118) scale(2.02248 2.01924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9231 40.395) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7872 39.6117) rotate(-90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1222 39.5321) rotate(90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0028 38.7482) rotate(180) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3919 40.2326) scale(4.55744 4.55014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FFA505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.1238 42.7835) scale(2.33574 2.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6405 40.3877) scale(2.27872 2.27507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9396 41.4161) scale(3.07301 3.06809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9582 43.2456) scale(1.85128 1.84831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8659 41.226) scale(2.12397 2.12057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7158 41.3409) scale(3.17594 3.17085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6777 44.4705) scale(3.25067 3.24547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1041 40.3659) scale(1.95511 1.95197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4215 41.4895) scale(4.41763 4.41056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4133 40.3848) scale(2.87349 2.86889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4138 43.6091) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4138 43.6092) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.124 41.3866) scale(2.02248 2.01924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3596 42.8698) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2237 42.0865) rotate(-90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5588 42.007) rotate(90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4393 41.2231) rotate(180) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8274 42.8487) scale(4.55744 4.55014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FFA505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5594 45.3996) scale(2.33574 2.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.076 43.0037) scale(2.27872 2.27507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.3751 44.0322) scale(3.07301 3.06809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3938 45.8617) scale(1.85128 1.84831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3015 43.8421) scale(2.12397 2.12057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.1513 43.957) scale(3.17594 3.17085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1132 47.0866) scale(3.25067 3.24547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5396 42.9819) scale(1.95511 1.95197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.857 44.1056) scale(4.41763 4.41056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8489 43.0009) scale(2.87349 2.86889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8494 46.2252) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8494 46.2252) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5595 44.0027) scale(2.02248 2.01924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7952 45.4859) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6593 44.7026) rotate(-90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9943 44.623) rotate(90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8749 43.8392) rotate(180) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.264 40.2326) scale(4.55744 4.55014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FFA505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9959 42.7835) scale(2.33574 2.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5126 40.3877) scale(2.27872 2.27507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8116 41.4161) scale(3.07301 3.06809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8303 43.2456) scale(1.85128 1.84831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.738 41.226) scale(2.12397 2.12057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5878 41.3409) scale(3.17594 3.17085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5497 44.4705) scale(3.25067 3.24547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9761 40.3659) scale(1.95511 1.95197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2935 41.4895) scale(4.41763 4.41056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2854 40.3848) scale(2.87349 2.86889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2859 43.6091) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2859 43.6092) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9961 41.3866) scale(2.02248 2.01924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2317 42.8698) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0958 42.0865) rotate(-90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4308 42.007) rotate(90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3114 41.2231) rotate(180) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6995 37.7579) scale(4.55744 4.55014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FFA505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4314 40.3088) scale(2.33574 2.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9481 37.9129) scale(2.27872 2.27507)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2472 38.9414) scale(3.07301 3.06809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2659 40.7709) scale(1.85128 1.84831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1735 38.7513) scale(2.12397 2.12057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0234 38.8661) scale(3.17594 3.17085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9853 41.9958) scale(3.25067 3.24547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4117 37.8911) scale(1.95511 1.95197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7291 39.0148) scale(4.41763 4.41056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7209 37.9101) scale(2.87349 2.86889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FFDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7214 41.1344) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7214 41.1344) scale(2.54682 2.54274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4316 38.9119) scale(2.02248 2.01924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6672 40.3951) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5313 39.6118) rotate(-90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8664 39.5322) rotate(90) scale(1.75621 1.75903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7469 38.7483) rotate(180) scale(1.75903 1.75621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8521",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5208 20.6625) scale(22.8818 10.5859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#C16F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#894F2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5185 20.6636) scale(22.8818 10.5859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2167 24.8067) scale(19.6649 9.27129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8204 24.481) scale(10.6206 4.91345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#846640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E4A1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.8394 20.2673) scale(26.7278 12.5885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5C38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5796 19.9215) scale(14.4897 16.2924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8606 19.8445) scale(9.9174 16.7721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_578_447492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5799 19.7247) scale(38.2609 16.1122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5C38",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.d1a07564982ccb5cb51aea088fb0c081.svg";
export { ForwardRef as ReactComponent };